// import React, { Component } from "react";
// import Loader from "../utils/loader";
// import userService from "../services/userService";
// import teamService from "../services/teamService";
// import Swal from "sweetalert2";
// import TeamCard from "./Cards/Teamcard";
// import { toast, ToastContainer } from "react-toastify";
// import PaginatioN from "react-js-pagination";
// import { paginate } from "../utils/paginate";
// import "./teamMembers.css";
// import Avatars from "./Avatar";
// import team from "../static/noteams.png";
// import isEmptyObject from "../utils/isEmptyObject";
// import { connect } from "react-redux";
// import { setCurrentUser } from "../redux/user/user.actions";
// import { ReactMultiEmail, isEmail } from "react-multi-email";
// import "react-multi-email/style.css";
// import _ from "lodash";
// import ReactTour from "./ReactTour";
// import { withRouter } from "react-router-dom";
// import ChatServices from "../services/ChatServices";
// import BasicAvatar from "./BasicAvatar";
// import { ChatContext } from "../contexts/ChatContext";
// import { addUserLogs } from "../services/userLogServices";
// import SubscriptionRequired from "./SubscriptionRequired";

// // MUI Imports
// import {
//   Box,
//   Card,
//   CardContent,
//   CardActions,
//   TextField,
//   Button,
//   Typography,
//   Divider,
//   Popover,
//   Tooltip,
//   Badge,
//   Avatar,
//   Checkbox,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Chip,
//   Paper,
//   InputAdornment,
//   Fade,
//   Zoom,
//   tooltipClasses
//   } from "@mui/material";
// import Grid2 from "@mui/material/Unstable_Grid2";
// import {
//   Add as AddIcon,
//   PersonAdd as PersonAddIcon,
//   Search as SearchIcon,
//   Delete as DeleteIcon,
//   Chat as ChatIcon,
//   Group as GroupIcon,
//   ExitToApp as ExitToAppIcon,
//   Close as CloseIcon,
//   HelpOutline as HelpIcon,
//   MoreVert as MoreVertIcon,
//   Person as PersonIcon,
//   ArrowBack as ArrowBackIcon,
//   ArrowForward as ArrowForwardIcon,
//   FirstPage as FirstPageIcon,
//   LastPage as LastPageIcon,
//   Email as EmailIcon,
//   Cancel as CancelIcon,
//   Create as CreateIcon,
//   Badge as BadgeIcon,
// } from "@mui/icons-material";
// import { styled, alpha, } from "@mui/material/styles";


// const LightTooltip = styled(({ className, ...props }) => (
//   <Tooltip {...props} arrow classes={{ popper: className }} />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: theme.palette.common.white,
//     color: theme.palette.primary.main, // better than hardcoded blue
//     boxShadow: theme.shadows[3],
//     fontSize: 12,
//     fontWeight: 500,
//     borderRadius: 8,
//     padding: "6px 12px",
//   },
//   [`& .${tooltipClasses.arrow}`]: {
//     color: theme.palette.common.white,
//   },
// }));

// // Styled Components
// const StyledCard = styled(Card)(({ theme }) => ({
//   height: "100%",
//   display: "flex",
//   flexDirection: "column",
//   transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//   borderRadius: 16,
//   overflow: "hidden",
//   "&:hover": {
//     transform: "translateY(-8px)",
//     boxShadow: theme.shadows[12],
//   },
// }));

// const GradientCard = styled(StyledCard)(({ theme }) => ({
//   background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
//   color: theme.palette.primary.contrastText,
// }));

// const SearchTextField = styled(TextField)(({ theme }) => ({
//   "& .MuiOutlinedInput-root": {
//     borderRadius: 50,
//     backgroundColor: alpha(theme.palette.common.white, 0.15),
//     "&:hover": {
//       backgroundColor: alpha(theme.palette.common.white, 0.25),
//     },
//     "&.Mui-focused": {
//       backgroundColor: alpha(theme.palette.common.white, 0.25),
//     },
//   },
// }));

// const ActionButton = styled(Button)(({ theme }) => ({
//   borderRadius: "20px !important",
//   width: "50% !important",
//   textTransform: "none",
//   fontWeight: 600,
//   boxShadow: theme.shadows[2],
//   backgroundColor: "#e7e3e3ff !important",
//   color: "#667eea !important",
//   "&:hover": {
//     boxShadow: theme.shadows[6],
//     backgroundColor: "#c6c3c3ff !important",
//   },
// }));

// // Dialog Styled Components
// const CustomDialog = styled(Dialog)(({ theme }) => ({
//   '& .MuiPaper-root': {
//     borderRadius: 20,
//     overflow: 'hidden',
//     background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.secondary.main, 0.05)} 100%)`,
//   }
// }));

// const DialogHeader = styled(DialogTitle)(({ theme, color }) => ({
//   background: `linear-gradient(135deg, ${color?.main || theme.palette.primary.main} 0%, ${color?.dark || theme.palette.primary.dark} 100%)`,
//   color: theme.palette.primary.contrastText,
//   display: 'flex',
//   justifyContent: 'space-between',
//   alignItems: 'center',
//   padding: theme.spacing(2.5, 3),
//   position: 'relative',
//   '&:after': {
//     content: '""',
//     position: 'absolute',
//     bottom: 0,
//     left: '5%',
//     width: '90%',
//     height: '2px',
//     background: `linear-gradient(90deg, transparent, ${alpha(theme.palette.primary.contrastText, 0.3)}, transparent)`,
//   }
// }));

// const colors = [
//   "#bff603",
//   "yellow",
//   "#80d4ff",
//   "orange",
//   "#ff8b94",
//   "#d3ffce",
//   "#9bb7d4",
//   "#ffdb58",
//   "#f1a7fe",
//   "#ff6961",
//   "#ffb347",
//   "#add8e6",
//   "#a0bfe6",
//   "#89cff0",
//   "#4f86f7",
//   "#67e6ec",
//   "#7fffd4",
//   "#77dd77",
//   "#b19cd9",
//   "#ff9999",
// ];

// const steps = [
//   {
//     selector: ".first-step",
//     content: "Create new group to add members",
//     position: "left",
//   },
//   {
//     selector: ".second-step",
//     content: "Enter email to send invite request to member",
//     position: "bottom",
//   },
// ];

// const stepsone = [
//   {
//     selector: ".first-step",
//     content: "Create new group to add members",
//     position: "left",
//   },
//   {
//     selector: ".second-step",
//     content: "Enter email to send invite request to member",
//     position: "bottom",
//   },
//   {
//     selector: ".third-step",
//     content: "Click to view/add members to the group",
//     position: "bottom",
//   },
// ];

// class Myteam extends Component {
//   state = {
//     loading: true,
//     userProfile: "",
//     inviteEmail: "",
//     inviteEmails: [],
//     teamMembers: [],
//     totalMemberCount: "",
//     currentPage: 1,
//     pageSize: 8,
//     searchQuery: "",
//     groups: [],
//     otherGroups: [],
//     groupMembers: [],
//     groupMemberIDs: [],
//     groupName: "",
//     groupId: "",
//     colorID: 0,
//     back: [],
//     color: ["#bff603", "yellow", "#80d4ff", "orange"],
//     filterTeam: [],
//     filterGroup: [],
//     filterGroupName: [],
//     filterOtherGroup: [],
//     selectedMembers: [],
//     userFeatures: {},
//     myGroupPage: 1,
//     otherGroupPage: 1,
//     reactTour: false,
//     subReqOpen: false,
//     inviteAnchorEl: null,
//     groupAnchorEl: null,
//     adminModalOpen: false,
//     sharedModalOpen: false,
//     inviteModalOpen: false,
//     createGroupModalOpen: false, // Changed from popover to modal
//   };

//   static contextType = ChatContext;

//   // ... (keep all existing methods exactly as they are, including:)
//   // searchOnChange, handleSearch, componentDidMount, componentDidUpdate,
//   // getProfile, getOtherGroups, getTeam, getGroup, handleDelete,
//   // handlePageChange, handleSendInvite, handleGroupName, sendInvite,
//   // setGroup, createGroup, onChangeSelectionBox, addMembersToGroup,
//   // removeMemberFromGroup, leaveGroup, deleteGroup, getPagedData,
//   // handleOpenChat, handleOpenGroupChat

//   searchOnChange = (e) => {
//     if (e.target.value === "") {
//       this.setState({
//         filterTeam: this.state.teamMembers,
//         filterGroup: this.state.groupMembers,
//       });
//     } else {
//       let value = e.target.value;
//       let teamMembers = this.state.teamMembers;
//       let groupMembers = this.state.groupMembers;
//       let result2 = [];
//       let result1 = [];
//       result1 = teamMembers.filter((member) => {
//         if (member.name.toLowerCase().search(value.toLowerCase()) !== -1) {
//           return member;
//         }
//       });
//       result2 = groupMembers.filter((group) => {
//         if (group.username.toLowerCase().search(value.toLowerCase()) !== -1) {
//           return group;
//         }
//       });

//       this.setState({ filterTeam: result1, filterGroup: result2 });
//     }
//   };

//   handleSearch = (e) => {
//     if (e.target.value === "") {
//       this.setState({
//         filterTeam: this.state.teamMembers,
//         filterGroupName: this.state.groups,
//         filterOtherGroup: this.state.otherGroups,
//       });
//     } else {
//       let value = e.target.value;
//       let teamMembers = this.state.teamMembers;
//       let groups = this.state.groups;
//       let otherGroups = this.state.otherGroups;

//       let result1 = teamMembers.filter((member) => {
//         if (member.name.toLowerCase().indexOf(value.toLowerCase()) > -1) {
//           return member;
//         }
//       });

//       let result2 = groups.filter((groupmember) => {
//         if (groupmember.name.toLowerCase().indexOf(value.toLowerCase()) > -1) {
//           return groupmember;
//         }
//       });

//       let result3 = otherGroups.filter((othergroupmember) => {
//         if (
//           othergroupmember.name.toLowerCase().indexOf(value.toLowerCase()) > -1
//         ) {
//           return othergroupmember;
//         }
//       });

//       this.setState({
//         filterTeam: result1,
//         filterGroupName: result2,
//         filterOtherGroup: result3,
//       });
//     }
//   };

//   async componentDidMount() {
//     setTimeout(() => {
//       if (this.props.hasAccess === false) {
//         this.setState({ subReqOpen: true, loading: false });
//       } else {
//         this.getTeam();
//       }
//     }, 2000);
//   }

//   async componentDidUpdate(prevProps, prevState) {
//     if (prevState.groupId !== this.state.groupId) {
//       this.setState({ selectedMembers: [] });
//     }
//   }

//   getProfile = async () => {
//     let user;
//     const { currentUser, setCurrentUser, features } = this.props;
//     if (currentUser && !isEmptyObject(currentUser)) {
//       user = await userService.getProfile();
//       user = user.data;
//     } else {
//       user = await userService.getProfile();
//       user = user.data;
//       setCurrentUser(user);
//     }
//     this.setState({ userProfile: user, userFeatures: features }, () => {
//       this.getOtherGroups();
//     });
//   };

//   getOtherGroups = async () => {
//     let other = this.state.userProfile.groups;

//     if (other.length > 0) {
//       const othergroups = await teamService.getGroupById(other);
//       this.setState({
//         otherGroups: othergroups.data,
//         filterOtherGroup: othergroups.data,
//       });
//     } else {
//       this.setState({ otherGroups: [] });
//     }
//     this.setState({ loading: false });
//   };

//   getTeam = async () => {
//     const teamMembers = await userService.getTeam();
//     if (teamMembers.status !== 200) {
//       this.setState({ teamMembers: [], filterTeam: [] }, () => {
//         this.getGroup();
//       });
//     } else {
//       this.setState(
//         {
//           filterTeam: teamMembers.data.user,
//           teamMembers: teamMembers.data.user,
//           totalMemberCount: teamMembers.data.user.length,
//         },
//         () => {
//           this.getGroup();
//         }
//       );
//     }
//   };

//   getGroup = async () => {
//     const group = await teamService.getAllGroups();
//     if (group.status === 200) {
//       this.setState({ groups: group.data, filterGroupName: group.data }, () => {
//         this.getProfile();
//       });
//     } else {
//       this.getProfile();
//     }
//   };

//   handleDelete = async (user) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: `Do you want to remove this team member`,
//       type: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, delete it!",
//       cancelButtonText: "No, keep it",
//     }).then(async (result) => {
//       if (result.value === true) {
//         this.setState({ loading: true });
//         let data = { id: user.id };
//         const team = await userService.deleteTeam(data);

//         if (team.status === 200) {
//           this.getTeam();
//           Swal.fire("Deleted!", `${team.message}`, "success");
//           const data = {
//             userId: sessionStorage.getItem("userId"),
//             organizationId: sessionStorage.getItem("organizationId"),
//             actionType: "deleteTeamMember",
//             userEmail: user.email,
//           };
//           const addLogs = await addUserLogs(data);
//           if (addLogs.status !== 200) {
//             toast.error(addLogs.message);
//           }
//         } else {
//           this.setState({ loading: false });
//           Swal.fire("Cancelled", `${team.message}`, "error");
//         }
//       } else {
//         Swal.fire("Cancelled", "Your team member is safe :)", "error");
//       }
//     });
//   };

//   handlePageChange = (page) => {
//     this.setState({ currentPage: page });
//   };

//   handleSendInvite = (e) => {
//     this.setState({
//       [e.target.name]: e.target.value,
//     });
//   };

//   handleGroupName = (e) => {
//     this.setState({
//       [e.target.name]: e.target.value,
//     });
//   };

//   sendInvite = async (e) => {
//     if (this.state.userFeatures?.TeamManagement === false) {
//       toast("Please upgrade your plan to enable team member features");
//       return;
//     }
//     this.setState({ loading: true });
//     e.preventDefault();
//     let email = this.state.inviteEmails;
//     if (email.length < 1) {
//       this.setState({ loading: false });
//       toast.error("Please enter valid email !");
//     } else {
//       const team = await teamService.inviteMember(email);
//       if (team.status !== 200) {
//         this.setState({ loading: false });
//         toast.error(team.message);
//       } else {
//         this.setState({ loading: false, inviteModalOpen: false });
//         toast.success(team.message);

//         const data = {
//           userId: sessionStorage.getItem("userId"),
//           organizationId: sessionStorage.getItem("organizationId"),
//           actionType: "inviteUser",
//           userEmail: email,
//         };
//         const addLogs = await addUserLogs(data);
//         if (addLogs.status !== 200) {
//           toast.error(addLogs.message);
//         }
//       }
//     }
//     this.setState({ inviteEmails: [] });
//   };

//   setGroup = async (groupid, groupmembers) => {
//     let team = this.state.filterTeam;
//     this.setState(
//       {
//         filterTeam: [],
//         groupMembers: [],
//         filterGroup: [],
//         groupId: groupid,
//         loading: true,
//       },
//       () => this.setState({ filterTeam: team })
//     );

//     if (groupmembers.length > 0) {
//       const groupdata = await teamService.getGroupMembers(groupmembers);
//       if (groupdata.status === 200) {
//         this.setState({
//           groupMembers: groupdata.data,
//           filterGroup: groupdata.data,
//         });
//       }
//     }
//     this.setState({ loading: false, groupMemberIDs: groupmembers });
//   };

//   createGroup = async (e) => {
//     e.preventDefault();
//     if (this.state.userFeatures?.TeamManagement === false) {
//       toast("Please upgrade your plan to enable team member features");
//       return;
//     }

//     this.setState({ loading: true });
//     let currentGroup = this.state.groups;
//     let groupName = this.state.groupName;
//     let userProfile = this.state.userProfile;
//     let match = 0;

//     if (groupName === "") {
//       this.setState({ loading: false });
//       toast.error(`Invalid Group Name!`);
//       return;
//     }

//     if (currentGroup.length > 0) {
//       for (let i = 0; i < currentGroup.length; i++) {
//         if (groupName === currentGroup[i].name) {
//           this.setState({ loading: false, groupName: "" });
//           toast(`${groupName} Already exists!`);
//           match = 1;
//           return;
//         }
//       }
//     }

//     if (match === 0) {
//       let data = {
//         groupname: groupName,
//         ownerName: userProfile.username,
//       };
//       const team = await teamService.createGroup(data);
//       if (team.status === 200) {
//         this.getGroup();
//         toast.success(team.message);
//         this.setState({ createGroupModalOpen: false });
//         const data = {
//           userId: sessionStorage.getItem("userId"),
//           organizationId: sessionStorage.getItem("organizationId"),
//           actionType: "createGroup",
//         };
//         const addLogs = await addUserLogs(data);
//         if (addLogs.status !== 200) {
//           toast.error(addLogs.message);
//         }
//       } else {
//         this.setState({ loading: false });
//         toast.error(team.message);
//       }
//     }

//     this.setState({ groupName: "" });
//   };

//   onChangeSelectionBox = (team) => (e) => {
//     let selected = this.state.selectedMembers;
//     if (e.target.checked === true) {
//       selected.push(team.id);
//     } else {
//       selected.splice(selected.indexOf(team.id), 1);
//     }
//     this.setState({ selectedMembers: selected });
//   };

//   addMembersToGroup = async () => {
//     let groupMembers = this.state.groupMemberIDs;
//     let selectedMembers = this.state.selectedMembers;

//     if (selectedMembers.length < 1) {
//       toast("No Member selected");
//       return;
//     } else {
//       let presents = _.intersectionWith(
//         groupMembers,
//         selectedMembers,
//         _.isEqual
//       );
//       if (presents.length > 0) {
//         for (let i = 0; i < presents.length; i++) {
//           selectedMembers.splice(selectedMembers.indexOf(presents[i]), 1);
//         }
//       }
//     }

//     if (selectedMembers.length > 0) {
//       let data = {
//         memberArray: selectedMembers,
//         groupID: this.state.groupId,
//       };

//       const res = await teamService.addMemberToGroup(data);
//       if (res.status === 200) {
//         this.getGroup();
//         toast.success(res.message);
//         this.setState({ adminModalOpen: false });
//       } else {
//         toast.error(res.message);
//       }
//       this.setState({ selectedMembers: [] });
//       return;
//     } else {
//       toast("Member already exists");
//       return;
//     }
//   };

//   removeMemberFromGroup = async (id) => {
//     let data = {
//       memberID: id,
//       groupID: this.state.groupId,
//     };

//     const res = await teamService.removeMemberFromGroup(data);
//     if (res.status === 200) {
//       this.getGroup();
//       toast.success(res.message);
//     } else {
//       toast.error(res.message);
//     }
//   };

//   leaveGroup = async () => {
//     this.setState({ loading: true, sharedModalOpen: false });
//     let data = {
//       _id: this.state.groupId,
//     };
//     const response = await teamService.leaveGroup(data);
//     if (response.status === 200) {
//       this.getProfile();
//       toast.success(response.message);
//     } else {
//       toast.error(response.message);
//       this.setState({ loading: false });
//     }
//   };

//   deleteGroup = async (group) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: `Do you want to delete ${group.name}`,
//       type: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, delete it!",
//       cancelButtonText: "No, keep it",
//     }).then(async (result) => {
//       if (result.value === true) {
//         this.setState({ loading: true });
//         let data = {
//           _id: group._id,
//           members: group.members,
//         };

//         const response = await teamService.deleteGroup(data);
//         if (response.status === 200) {
//           this.getGroup();
//           Swal.fire("Deleted!", `${response.message}`, "success");
//           const data = {
//             userId: sessionStorage.getItem("userId"),
//             organizationId: sessionStorage.getItem("organizationId"),
//             actionType: "deleteGroup",
//           };
//           const addLogs = await addUserLogs(data);
//           if (addLogs.status !== 200) {
//             toast.error(addLogs.message);
//           }
//         } else {
//           this.setState({ loading: false });
//           Swal.fire("Cancelled", `${response.message}`, "error");
//         }
//       } else {
//         Swal.fire("Cancelled", "Your Group is safe :)", "error");
//       }
//     });
//   };

//   getPagedData = () => {
//     let {
//       teamMembers,
//       currentPage,
//       pageSize,
//       searchQuery,
//       filterGroupName,
//       filterOtherGroup,
//     } = this.state;

//     let filteredMembers = teamMembers;

//     if (searchQuery) {
//       filteredMembers = teamMembers.filter((team) =>
//         team.name.toLowerCase().startsWith(searchQuery.toLowerCase())
//       );
//       filterGroupName = filterGroupName.filter((team) =>
//         team.name.toLowerCase().startsWith(searchQuery.toLowerCase())
//       );
//       filterOtherGroup = filterOtherGroup.filter((team) =>
//         team.name.toLowerCase().startsWith(searchQuery.toLowerCase())
//       );
//     }

//     const team = paginate(filteredMembers, currentPage, pageSize);
//     const myGroups = paginate(filterGroupName, this.state.myGroupPage, 9);
//     const otherGroups = paginate(
//       filterOtherGroup,
//       this.state.otherGroupPage,
//       9
//     );

//     return {
//       totalMemberCount: filteredMembers.length,
//       teamMembers: team,
//       myGroups: myGroups,
//       paginateOtherGroups: otherGroups,
//       myGroupsCount: filterGroupName.length,
//       otherGroupsCount: filterOtherGroup.length,
//     };
//   };

//   handleOpenChat = async (id) => {
//     var userProfile = this.state.userProfile;
//     try {
//       const response = await ChatServices.createContact(userProfile._id, id);
//       if (response.status === 200) {
//         const { history } = this.props;
//         history.push({
//           pathname: `/chat`,
//         });
//       }
//     } catch (error) {
//       console.error("Error calling backend API:", error.message);
//     }
//   };

//   handleOpenGroupChat = async (groupName, selectedContacts, groupId) => {
//     try {
//       if (!this.props.hasAccessToChat) {
//         this.setState({ subReqOpen: true });
//         return;
//       }
//       const response = await ChatServices.createGroup(
//         groupName,
//         selectedContacts,
//         groupId
//       );
//       if (response.status === 200) {
//         const { history } = this.props;
//         history.push({
//           pathname: `/chat`,
//         });
//       }
//     } catch (error) {
//       console.error("Error calling backend API:", error.message);
//     }
//   };

//   // Custom Email Chip Component
//   EmailChip = ({ email, index, removeEmail }) => (
//     <Chip
//       key={index}
//       label={email}
//       onDelete={() => removeEmail(index)}
//       deleteIcon={<CancelIcon />}
//       size="medium"
//       color="primary"
//       variant="outlined"
//       sx={{
//         m: 0.5,
//         backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
//         borderColor: (theme) => alpha(theme.palette.primary.main, 0.3),
//         '& .MuiChip-deleteIcon': {
//           color: (theme) => theme.palette.error.main,
//           '&:hover': {
//             color: (theme) => theme.palette.error.dark,
//           }
//         }
//       }}
//     />
//   );

//   render() {
//     let {
//       filterTeam,
//       filterGroup,
//       filterGroupName,
//       filterOtherGroup,
//       subReqOpen,
//       adminModalOpen,
//       sharedModalOpen,
//       inviteModalOpen,
//       createGroupModalOpen,
//       inviteEmails,
//       groupName,
//     } = this.state;

//     let {
//       teamMembers,
//       totalMemberCount,
//       myGroups,
//       paginateOtherGroups,
//       myGroupsCount,
//       otherGroupsCount,
//     } = this.getPagedData();

//     return (
//       <Box sx={{ p: 3, bgcolor: "#f5f5f5", minHeight: "100vh" }}>
//         <Loader loading={this.state.loading} />
//         <SubscriptionRequired
//           open={subReqOpen}
//           setOpen={(val) => this.setState({ subReqOpen: val })}
//         />
//         <ToastContainer />


//   <div
//   style={{
//     height: "10vh",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//   }}
// >
//   <h2
//     style={{
//       color: "#012a83",
//       fontSize: "15px",
//       fontWeight: "100",
//       fontstyle:"bold",
//       letterSpacing: "2px",
//       margin: 0,
//     }}
//   >
//     TEAM WORKSPACE
//   </h2>
// </div>
//         {/* Header Section */}
//         <Paper
//           elevation={0}
//           sx={{
//             p: 3,
//             mb: 3,
//             borderRadius: 3,
//             background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//             position: "relative",
//             overflow: "hidden",
//             "&:before": {
//               content: '""',
//               position: "absolute",
//               top: -50,
//               right: -50,
//               width: 150,
//               height: 150,
//               background: "rgba(255,255,255,0.1)",
//               borderRadius: "50%",
//             },
//           }}
//         >
//           <Grid2 container spacing={2} alignItems="center">
//             <Grid2 xs={12} md={6}>
//               <SearchTextField
//                 fullWidth
//                 placeholder="Search groups or team members..."
//                 onChange={this.handleSearch}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <SearchIcon sx={{ color: "white" }} />
//                     </InputAdornment>
//                   ),
//                   sx: { 
//                     color: "white", 
//                     background: "rgba(255,255,255,0.1) !important",
//                     "& .MuiOutlinedInput-notchedOutline": {
//                       borderColor: "rgba(255,255,255,0.3) !important",
//                     },
//                     "&:hover .MuiOutlinedInput-notchedOutline": {
//                       borderColor: "rgba(255,255,255,0.5) !important",
//                     },
//                     "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                       borderColor: "white !important",
//                     }
//                   },
//                 }}
//               />
//             </Grid2>

//             <Grid2 xs={12} md={6}>
//               <Box
//                 sx={{
//                   display: "flex",
//                   gap: 2,
//                   justifyContent: { xs: "flex-start", md: "flex-end" },
//                 }}
//               >
//                 <ActionButton
//                   className="first-step"
//                   variant="contained"
//                   startIcon={<AddIcon />}
//                   onClick={() => this.setState({ createGroupModalOpen: true })}
//                   sx={{
//                     background: "linear-gradient(135deg, #fff 0%, #f5f5f5 100%) !important",
//                     color: "#667eea !important",
//                     "&:hover": { 
//                       background: "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%) !important",
//                       transform: "translateY(-2px)",
//                     },
//                   }}
//                 >
//                   Create Group
//                 </ActionButton>

//                 <ActionButton
//                   className="second-step"
//                   variant="contained"
//                   startIcon={<PersonAddIcon />}
//                   onClick={() => this.setState({ inviteModalOpen: true })}
//                   sx={{
//                     background: "linear-gradient(135deg, #fff 0%, #f5f5f5 100%) !important",
//                     color: "#667eea !important",
//                     "&:hover": { 
//                       background: "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%) !important",
//                       transform: "translateY(-2px)",
//                     },
//                   }}
//                 >
//                   Invite
//                 </ActionButton>

//                 <LightTooltip title="Need Help?">
//                   <IconButton
//                     onClick={() => this.setState({ reactTour: true })}
//                     sx={{
//                       background: "linear-gradient(135deg, #fff 0%, #f5f5f5 100%) !important",
//                       color: "#4762d8 !important",
//                       "&:hover": { 
//                         background: "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%) !important",
//                         transform: "translateY(-2px)",
//                       },
//                       width: 48,
//                       height: 48,
//                     }}
//                   >
//                     <HelpIcon />
//                   </IconButton>
//                 </LightTooltip>
//               </Box>
//             </Grid2>
//           </Grid2>
//         </Paper>

//         {/* Create Group Modal */}
//         <CustomDialog
//           open={createGroupModalOpen}
//           onClose={() => this.setState({ createGroupModalOpen: false, groupName: "" })}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogHeader color={{ main: "#667eea", dark: "#764ba2" }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//               <CreateIcon fontSize="large" />
//               <Box>
//                 <Typography variant="h5" fontWeight={700}>
//                   Create New Group
//                 </Typography>
//                 <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                   Organize team members into groups
//                 </Typography>
//               </Box>
//             </Box>
//             {/* <IconButton
//               onClick={() => this.setState({ createGroupModalOpen: false, groupName: "" })}
//               sx={{
//                 color: "white !important",
//                 backgroundColor: "#ff4444 !important",
//                 '&:hover': {
//                   backgroundColor: 'rgba(255, 68, 68, 0.2)',
//                 }
//               }}
//               size="small"
//             >
//               <CloseIcon />
//             </IconButton> */}
//           </DialogHeader>

//           <DialogContent sx={{ p: 3, pt: 4 }}>
//             <form onSubmit={this.createGroup}>
//               <Box sx={{ mb: 1, mt: 2 }}>
//                 <TextField
//                   fullWidth
//                   placeholder="Enter group name"
//                   name="groupName"
//                   value={groupName}
//                   onChange={this.handleGroupName}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <BadgeIcon sx={{ color: "primary.main" }} />
//                       </InputAdornment>
//                     ),
//                     sx: { 
//                       borderRadius: 2,
//                       "& .MuiOutlinedInput-input": {
//                         padding: "12px 14px",
//                       }
//                     }
//                   }}
//                   helperText="Choose a unique name for your group"
//                   FormHelperTextProps={{
//                     sx: { ml: 0, mt: 1 }
//                   }}
//                 />
//               </Box>

//               {/* <Box sx={{ 
//                 backgroundColor: (theme) => alpha(theme.palette.info.main, 0.1),
//                 borderRadius: 2,
//                 p: 1,
//                 mb: 1
//               }}>
//                 <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                   <HelpIcon fontSize="small" />
//                   You can add members to this group after creation
//                 </Typography>
//               </Box> */}

//               <Box sx={{ 
//                 display: 'flex', 
//                 alignItems: 'center', 
//                 gap: 2,
//                 backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.05),
//                 p: 2,
//                 borderRadius: 2,
//                 border: (theme) => `1px dashed ${alpha(theme.palette.primary.main, 0.3)}`
//               }}>
//                 <GroupIcon color="primary" />
//                 <Box>
//                   <Typography variant="body2" fontWeight={500} color="primary">
//                     Group Benefits
//                   </Typography>
//                   <Typography variant="caption" color="text.primary">
//                     • Organized collaboration • Group chats • Shared resources
//                   </Typography>
//                 </Box>
//               </Box>
//             </form>
//           </DialogContent>

//           <DialogActions sx={{ p: 3, borderTop: 1, borderColor: 'divider' }}>
//             <Button
//               onClick={() => this.setState({ createGroupModalOpen: false, groupName: "" })}
//               sx={{ borderRadius: 2 }}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="contained"
//               onClick={this.createGroup}
//               disabled={!groupName.trim()}
//               startIcon={<CreateIcon />}
//               sx={{
//                 background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                 color: 'white !important',
//                 '&:hover': {
//                   background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
//                   color: 'white !important',
//                 },
//                 minWidth: '150px',
//                 minHeight: '35px',
//                 borderRadius: 2,
//               }}
//             >
//               Create Group
//             </Button>
//           </DialogActions>
//         </CustomDialog>

//         {/* Improved Invite Team Members Modal */}
//         <CustomDialog
//           open={inviteModalOpen}
//           onClose={() => this.setState({ inviteModalOpen: false, inviteEmails: [] })}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogHeader color={{ main: "#667eea", dark: "#764ba2" }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//               <EmailIcon fontSize="large" />
//               <Box>
//                 <Typography variant="h5" fontWeight={700}>
//                   Invite Team Members
//                 </Typography>
//                 <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                   Send email invitations to collaborate
//                 </Typography>
//               </Box>
//             </Box>
//             {/* <IconButton
//               onClick={() => this.setState({ inviteModalOpen: false, inviteEmails: [] })}
//               sx={{
//                 color: "white !important",
//                 backgroundColor: "#ff4444 !important",
//                 '&:hover': {
//                   backgroundColor: 'rgba(255, 68, 68, 0.2)',
//                 }
//               }}
//               size="small"
//             >
//               <CloseIcon />
//             </IconButton> */}
//           </DialogHeader>

//           <DialogContent sx={{ p: 3 }}>
//             <Box sx={{ mb: 1, pt: 3 }}>
//               <ReactMultiEmail
//                 placeholder="Enter email addresses..."
//                 emails={inviteEmails}
//                 onChange={(_emails) => {
//                   this.setState({ inviteEmails: _emails });
//                 }}
//                 validateEmail={(email) => isEmail(email)}
//                 getLabel={(email, index, removeEmail) => (
//                   <this.EmailChip
//                     email={email}
//                     index={index}
//                     removeEmail={removeEmail}
//                   />
//                 )}
//                 inputProps={{
//                   style: {
//                     width: '100%',
//                     border: 'none',
//                     outline: 'none',
//                     padding: '8px 0',
//                     fontSize: '16px',
//                     backgroundColor: 'transparent',
//                   },
//                 }}
//               />

//               {inviteEmails.length > 0 && (
//                 <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
//                   <Typography variant="caption" color="text.primary">
//                     {inviteEmails.length} email{inviteEmails.length !== 1 ? 's' : ''} added
//                   </Typography>
//                   <Chip
//                     label="Clear All"
//                     size="small"
//                     onClick={() => this.setState({ inviteEmails: [] })}
//                     sx={{
//                       cursor: 'pointer',
//                       backgroundColor: 'error.main',
//                       color: 'white',
//                       '&:hover': {
//                         backgroundColor: 'error.dark',
//                       }
//                     }}
//                   />
//                 </Box>
//               )}
//             </Box>

//             <Box sx={{ 
//               backgroundColor: (theme) => alpha(theme.palette.info.main, 0.1),
//               borderRadius: 2,
//               p: 1
//             }}>
//               <Typography variant="body2" color="text.primary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <HelpIcon fontSize="small" />
//                 *Multiple invites can be sent
//               </Typography>
//             </Box>
//           </DialogContent>

//           <DialogActions sx={{ p: 3, borderTop: 1, borderColor: 'divider' }}>
//             <Button
//               onClick={() => this.setState({ inviteModalOpen: false, inviteEmails: [] })}
//               sx={{ borderRadius: 2 }}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="contained"
//               onClick={this.sendInvite}
//               disabled={inviteEmails.length === 0}
//               startIcon={<PersonAddIcon />}
//               sx={{
//                 background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                 color: 'white !important',
//                 '&:hover': {
//                   background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
//                   color: 'white !important',
//                 },
//                 minWidth: '150px',
//                 minHeight: '35px',
//                 borderRadius: 2,
//               }}
//             >
//               Send Invites ({inviteEmails.length})
//             </Button>
//           </DialogActions>
//         </CustomDialog>

//         {/* Empty State */}
//         {teamMembers.length === 0 &&
//         this.state.groups.length === 0 &&
//         this.state.otherGroups.length === 0 ? (
//           <Box sx={{ textAlign: "center", py: 8 }}>
//             <img
//               src={team}
//               alt="No teams"
//               style={{ maxWidth: "400px", opacity: 0.7 }}
//             />
//             <Typography variant="h5" color="text.primary" sx={{ mt: 3 }}>
//               No teams or groups yet
//             </Typography>
//             <Typography variant="body2" color="text.primary" sx={{ mt: 1 }}>
//               Create a group or invite team members to get started
//             </Typography>
//           </Box>
//         ) : (
//           <>
//             {/* Team Members Section */}
//             {teamMembers.length > 0 && (
//               <Fade in timeout={800}>
//                 <Box sx={{ mb: 4 }}>
//                   <Typography
//                     variant="h5"
//                     fontWeight={600}
//                     gutterBottom
//                     sx={{ mb: 3, display: 'flex', alignItems: 'center' }}
//                   >
//                     <Box sx={{
//                       width: 4,
//                       height: 24,
//                       background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                       borderRadius: 2,
//                       mr: 2
//                     }} />
//                     <GroupIcon
//                       sx={{
//                         mr: 1,
//                         verticalAlign: "middle",
//                         color: "primary.main",
//                       }}
//                     />
//                     Team Members
//                     <Chip
//                       label={`${teamMembers.length} members`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ ml: 2 }}
//                     />
//                   </Typography>
//                   <Grid2 container spacing={2}>
//                     {filterTeam.map((team) => (
//                       <Grid2 xs={12} sm={6} md={4} lg={3} key={team.id}>
//                         <TeamCard
//                           teamdata={team}
//                           grpData={this.state.groups}
//                           deleteMember={() => this.handleDelete(team)}
//                           openChat={() => this.handleOpenChat(team?.id)}
//                         />
//                       </Grid2>
//                     ))}
//                   </Grid2>

//                   {totalMemberCount > 8 && (
//                     <Box
//                       sx={{ display: "flex", justifyContent: "center", mt: 3 }}
//                     >
//                       <PaginatioN
//                         activePage={this.state.currentPage}
//                         itemsCountPerPage={this.state.pageSize}
//                         totalItemsCount={totalMemberCount}
//                         pageRangeDisplayed={3}
//                         onChange={this.handlePageChange}
//                         itemClass="page-item"
//                         linkClass="page-link"
//                       />
//                     </Box>
//                   )}
//                 </Box>
//               </Fade>
//             )}

//             {/* My Groups Section */}
//             {this.state.groups.length > 0 && (
//               <Fade in timeout={1000}>
//                 <Box sx={{ mb: 4 }}>
//                   <Typography
//                     variant="h5"
//                     fontWeight={600}
//                     gutterBottom
//                     sx={{ mb: 3, display: 'flex', alignItems: 'center' }}
//                   >
//                     <Box sx={{
//                       width: 4,
//                       height: 24,
//                       background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                       borderRadius: 2,
//                       mr: 2
//                     }} />
//                     <GroupIcon
//                       sx={{
//                         mr: 1,
//                         verticalAlign: "middle",
//                         color: "primary.main",
//                       }}
//                     />
//                     My Groups
//                     <Chip
//                       label={`${myGroupsCount} Groups`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ ml: 2, fontWeight: 500 }}
//                     />
//                   </Typography>
//                   <Grid2 container spacing={3}>
//                     {filterGroupName.length > 0 &&
//                       myGroups.map((group, index) => (
//                         <Grid2 xs={12} sm={4} md={2} lg={3} key={group._id}>
//                           <Zoom in timeout={300 + index * 100}>
//                             <StyledCard className="third-step">
//                               {/* Card Header with Gradient */}
//                               <Box
//                                 sx={{
//                                   background:
//                                     "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                                   py: 1.5,
//                                   textAlign: "center",
//                                   position: "relative",
//                                   '&:hover': {
//                                     background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
//                                   }
//                                 }}
//                               >
//                                 <Box
//                                   onClick={() =>
//                                     this.setGroup(group._id, group.members)
//                                   }
//                                   sx={{ cursor: "pointer" }}
//                                 >
//                                   <Box
//                                     sx={{
//                                       display: "inline-flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                       width: 50,
//                                       height: 50,
//                                       borderRadius: "50%",
//                                       bgcolor: "rgba(255,255,255,0.2)",
//                                       border: "3px solid rgba(255,255,255,0.3)",
//                                       transition: 'all 0.3s',
//                                       '&:hover': {
//                                         transform: 'scale(1.1)',
//                                         boxShadow: '0 0 20px rgba(255,255,255,0.3)'
//                                       }
//                                     }}
//                                   >
//                                     <Typography
//                                       variant="h5"
//                                       fontWeight={700}
//                                       color="white"
//                                     >
//                                       {group.name.charAt(0).toUpperCase()}
//                                     </Typography>
//                                   </Box>
//                                 </Box>
//                               </Box>

//                               <CardContent sx={{ flexGrow: 1, pt: 2 }}>
//                                 {/* Group Name */}
//                                 <Typography
//                                   variant="h6"
//                                   fontWeight={600}
//                                   sx={{
//                                     mb: 1,
//                                     overflow: "hidden",
//                                     textOverflow: "ellipsis",
//                                     whiteSpace: "nowrap",
//                                   }}
//                                   title={group.name}
//                                 >
//                                   {group.name}
//                                 </Typography>

//                                 {/* Admin Info */}
//                                 <Box
//                                   sx={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     mb: 2,
//                                   }}
//                                 >
//                                   <PersonIcon
//                                     fontSize="small"
//                                     sx={{ mr: 0.5, color: "text.primary" }}
//                                   />
//                                   <Typography
//                                     variant="body2"
//                                     color="text.primary"
//                                   >
//                                     Admin:{" "}
//                                     <span
//                                       style={{
//                                         fontWeight: 500,
//                                         color: "primary.main",
//                                       }}
//                                     >
//                                       {this.state.userProfile.username}
//                                     </span>
//                                   </Typography>
//                                 </Box>

//                                 {/* Members Count */}
//                                 <Chip
//                                   icon={<GroupIcon fontSize="small" />}
//                                   label={`${group.members.length} ${
//                                     group.members.length === 1
//                                       ? "member"
//                                       : "members"
//                                   }`}
//                                   size="small"
//                                   variant="outlined"
//                                   sx={{ mb: 1 }}
//                                 />
//                               </CardContent>

//                               {/* Action Buttons */}
//                               <CardActions
//                                 sx={{
//                                   p: 1.5,
//                                   bgcolor: "background.default",
//                                   borderTop: "1px solid",
//                                   borderColor: "divider",
//                                 }}
//                               >
//                                 <Box
//                                   sx={{
//                                     display: "flex",
//                                     justifyContent: "space-between",
//                                     width: "100%",
//                                   }}
//                                 >
//                                   {/* Chat Button */}
//                                   <LightTooltip title="Open Group Chat">
//                                     <Button
//                                       variant="contained"
//                                       size="small"
//                                       startIcon={<ChatIcon />}
//                                       onClick={() =>
//                                         this.handleOpenGroupChat(
//                                           group.name,
//                                           group.members,
//                                           group._id
//                                         )
//                                       }
//                                       sx={{
//                                         borderRadius: 3,
//                                         px: 2,
//                                         background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                                         color: 'white',
//                                         "&:hover": { 
//                                           background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
//                                           transform: 'translateY(-2px)'
//                                         },
//                                       }}
//                                     >
//                                       <Badge
//                                         badgeContent={group.unreadCount}
//                                         color="error"
//                                         sx={{ mr: 1 }}
//                                       >
//                                         Chat
//                                       </Badge>
//                                     </Button>
//                                   </LightTooltip>

//                                   {/* Action Buttons Group */}
//                                   <Box sx={{ display: "flex", gap: 0.5 }}>
//                                     {/* View Members */}
//                                     <LightTooltip title="View Members">
//                                       <IconButton
//                                         size="small"
//                                         color="primary"
//                                         onClick={() => {
//                                           this.setGroup(
//                                             group._id,
//                                             group.members
//                                           );
//                                           this.setState({
//                                             adminModalOpen: true,
//                                           });
//                                         }}
//                                         sx={{
//                                           bgcolor: "primary.light",
//                                           color: "primary.contrastText",
//                                           "&:hover": {
//                                             bgcolor: "primary.main",
//                                             transform: 'translateY(-2px)'
//                                           },
//                                         }}
//                                       >
//                                         <GroupIcon fontSize="small" />
//                                       </IconButton>
//                                     </LightTooltip>

//                                     {/* Delete Group */}
//                                     <LightTooltip title="Delete Group">
//                                       <IconButton
//                                         size="small"
//                                         onClick={() => this.deleteGroup(group)}
//                                         sx={{
//                                           "& .MuiSvgIcon-root": {
//                                             color: "#f44336",
//                                           },
//                                           "&:hover": {
//                                             backgroundColor: "rgba(244, 67, 54, 0.1)",
//                                             transform: 'translateY(-2px)',
//                                             "& .MuiSvgIcon-root": {
//                                               color: "#d32f2f",
//                                             },
//                                           },
//                                         }}
//                                       >
//                                         <DeleteIcon />
//                                       </IconButton>
//                                     </LightTooltip>
//                                   </Box>
//                                 </Box>
//                               </CardActions>
//                             </StyledCard>
//                           </Zoom>
//                         </Grid2>
//                       ))}
//                   </Grid2>

//                   {/* My Groups Pagination */}
//                   {myGroupsCount > 9 && (
//                     <Paper
//                       elevation={0}
//                       sx={{
//                         p: 2,
//                         mt: 3,
//                         borderRadius: 3,
//                         bgcolor: "background.default",
//                         border: "1px solid",
//                         borderColor: "divider",
//                         boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
//                       }}
//                     >
//                       <Box sx={{ display: "flex", justifyContent: "center" }}>
//                         <PaginatioN
//                           activePage={this.state.myGroupPage}
//                           itemsCountPerPage={9}
//                           totalItemsCount={myGroupsCount}
//                           pageRangeDisplayed={5}
//                           onChange={(page) =>
//                             this.setState({ myGroupPage: page })
//                           }
//                           itemClass="page-item"
//                           linkClass="page-link"
//                           prevPageText={<ArrowBackIcon />}
//                           nextPageText={<ArrowForwardIcon />}
//                           firstPageText={<FirstPageIcon />}
//                           lastPageText={<LastPageIcon />}
//                         />
//                       </Box>
//                     </Paper>
//                   )}
//                 </Box>
//               </Fade>
//             )}

//             {/* Shared Groups Section */}
//             {this.state.otherGroups.length > 0 && (
//               <Fade in timeout={1200}>
//                 <Box sx={{ mb: 4 }}>
//                   <Typography
//                     variant="h5"
//                     fontWeight={600}
//                     gutterBottom
//                     sx={{ mb: 3, display: 'flex', alignItems: 'center' }}
//                   >
//                     <Box sx={{
//                       width: 4,
//                       height: 24,
//                       background: 'linear-gradient(135deg, #FF9800 0%, #FF5722 100%)',
//                       borderRadius: 2,
//                       mr: 2
//                     }} />
//                     <GroupIcon
//                       sx={{
//                         mr: 1,
//                         verticalAlign: "middle",
//                         color: "warning.main",
//                       }}
//                     />
//                     Shared Groups
//                     <Chip
//                       label={`${otherGroupsCount} Groups`}
//                       size="small"
//                       color="warning"
//                       variant="outlined"
//                       sx={{ ml: 2, fontWeight: 500 }}
//                     />
//                   </Typography>
//                   <Grid2 container spacing={3}>
//                     {filterOtherGroup.length > 0 &&
//                       paginateOtherGroups.map((group, index) => (
//                         <Grid2 xs={12} sm={6} md={4} lg={3} key={group._id}>
//                           <Zoom in timeout={400 + index * 100}>
//                             <StyledCard
//                               sx={{
//                                 background: 'linear-gradient(135deg, #ffffff 0%, #f9f9f9 100%)',
//                                 '&:hover': {
//                                   background: 'linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%)',
//                                 }
//                               }}
//                             >
//                               <CardContent sx={{ textAlign: "center", pt: 3 }}>
//                                 <Box
//                                   onClick={() =>
//                                     this.setGroup(group._id, group.members)
//                                   }
//                                   sx={{ cursor: "pointer" }}
//                                 >
//                                   <Box
//                                     sx={{
//                                       display: "inline-flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                       width: 60,
//                                       height: 60,
//                                       borderRadius: "50%",
//                                       background: 'linear-gradient(135deg, #FF9800 0%, #FF5722 100%)',
//                                       mb: 2,
//                                       boxShadow: '0 4px 12px rgba(255, 152, 0, 0.3)'
//                                     }}
//                                   >
//                                     <Typography
//                                       variant="h4"
//                                       fontWeight={700}
//                                       color="white"
//                                     >
//                                       {group.name.charAt(0).toUpperCase()}
//                                     </Typography>
//                                   </Box>
//                                   <Typography
//                                     variant="h6"
//                                     fontWeight={600}
//                                     sx={{ mt: 2, mb: 0.5 }}
//                                   >
//                                     {group.name}
//                                   </Typography>
//                                   <Typography
//                                     variant="body2"
//                                     color="text.primary"
//                                     sx={{ mb: 1 }}
//                                   >
//                                     Admin: {group.ownerName}
//                                   </Typography>
//                                   <Chip
//                                     icon={<GroupIcon fontSize="small" />}
//                                     label={`${group.members.length} ${
//                                       group.members.length === 1
//                                         ? "member"
//                                         : "members"
//                                     }`}
//                                     size="small"
//                                     color="warning"
//                                     variant="outlined"
//                                     sx={{ mt: 1 }}
//                                   />
//                                 </Box>
//                               </CardContent>
//                               <CardActions sx={{ justifyContent: "center", pb: 2 }}>
//                                 <Button
//                                   variant="contained"
//                                   color="warning"
//                                   onClick={() => {
//                                     this.setGroup(group._id, group.members);
//                                     this.setState({ sharedModalOpen: true });
//                                   }}
//                                   startIcon={<GroupIcon />}
//                                   sx={{
//                                     borderRadius: 3,
//                                     px: 3,
//                                     background: 'linear-gradient(135deg, #FF9800 0%, #FF5722 100%)',
//                                     color: 'white',
//                                     "&:hover": {
//                                       background: 'linear-gradient(135deg, #FF5722 0%, #FF9800 100%)',
//                                       transform: 'translateY(-2px)'
//                                     },
//                                   }}
//                                 >
//                                   View Members
//                                 </Button>
//                               </CardActions>
//                             </StyledCard>
//                           </Zoom>
//                         </Grid2>
//                       ))}
//                   </Grid2>
//                 </Box>
//               </Fade>
//             )}
//           </>
//         )}

//         {/* Admin Group Modal */}
//         <CustomDialog
//           open={adminModalOpen}
//           onClose={() => this.setState({ adminModalOpen: false })}
//           maxWidth="lg"
//           fullWidth
//         >
//           <DialogHeader color={{ main: "#667eea", dark: "#764ba2" }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//               <GroupIcon fontSize="large" />
//               <Box>
//                 <Typography variant="h5" fontWeight={700}>
//                   Manage Group Members
//                 </Typography>
//                 <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                   Add or remove members from your group
//                 </Typography>
//               </Box>
//             </Box>
//             <IconButton
//               onClick={() => this.setState({ adminModalOpen: false })}
//               sx={{
//                 color: "white !important",
//                 backgroundColor: "#ff4444 !important",
//                 "&:hover": {
//                   backgroundColor: 'rgba(255, 68, 68, 0.2)',
//                 },
//               }}
//             >
//               <CloseIcon />
//             </IconButton>
//           </DialogHeader>

//           <DialogContent sx={{ p: 0 }}>
//             <Paper
//               elevation={0}
//               sx={{ p: 3, borderBottom: 1, borderColor: "divider" }}
//             >
//               <SearchTextField
//                 fullWidth
//                 placeholder="Search members by name..."
//                 onChange={this.searchOnChange}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <SearchIcon />
//                     </InputAdornment>
//                   ),
//                   sx: { 
//                     borderRadius: 2,
//                     backgroundColor: '#f5f5f5'
//                   },
//                 }}
//               />
//             </Paper>

//             <Grid2 container spacing={0} sx={{ height: "60vh" }}>
//               <Grid2
//                 xs={12}
//                 md={6}
//                 sx={{
//                   borderRight: { md: 1 },
//                   borderColor: "divider",
//                   height: "100%",
//                   display: "flex",
//                   flexDirection: "column",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     p: 3,
//                     borderBottom: 1,
//                     borderColor: "divider",
//                     bgcolor: "background.default",
//                   }}
//                 >
//                   <Typography variant="h6" fontWeight={600} gutterBottom>
//                     <Badge
//                       badgeContent={filterGroup.length}
//                       color="primary"
//                       sx={{ mr: 1 }}
//                     >
//                       Current Members
//                     </Badge>
//                   </Typography>
//                   <Typography variant="body2" color="text.primary">
//                     Members currently in this group
//                   </Typography>
//                 </Box>

//                 <Box
//                   sx={{
//                     flex: 1,
//                     overflowY: "auto",
//                     p: 2,
//                     bgcolor: "background.default",
//                   }}
//                 >
//                   {filterGroup.length > 0 ? (
//                     <Grid2 container spacing={2}>
//                       {filterGroup.map((group) => (
//                         <Grid2 xs={12} key={group._id}>
//                           <Paper
//                             elevation={0}
//                             sx={{
//                               p: 2,
//                               borderRadius: 2,
//                               border: "1px solid",
//                               borderColor: "divider",
//                               transition: "all 0.2s",
//                               "&:hover": {
//                                 borderColor: "primary.main",
//                                 boxShadow: '0 4px 12px rgba(102, 126, 234, 0.1)',
//                               },
//                             }}
//                           >
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "space-between",
//                               }}
//                             >
//                               <Box
//                                 sx={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: 2,
//                                 }}
//                               >
//                                 <Badge
//                                   overlap="circular"
//                                   anchorOrigin={{
//                                     vertical: "bottom",
//                                     horizontal: "right",
//                                   }}
//                                   variant="dot"
//                                   color={
//                                     group.status === "online"
//                                       ? "success"
//                                       : "default"
//                                   }
//                                 >
//                                   <Avatar
//                                     sx={{
//                                       bgcolor:
//                                         colors[
//                                           filterGroup.indexOf(group) %
//                                             colors.length
//                                         ],
//                                       width: 48,
//                                       height: 48,
//                                       fontWeight: 600,
//                                       fontSize: "1.25rem",
//                                       boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
//                                     }}
//                                   >
//                                     {group.username.charAt(0).toUpperCase()}
//                                   </Avatar>
//                                 </Badge>
//                                 <Box>
//                                   <Typography
//                                     variant="subtitle1"
//                                     fontWeight={600}
//                                   >
//                                     {group.username}
//                                   </Typography>
//                                   <Typography
//                                     variant="caption"
//                                     color="text.primary"
//                                   >
//                                     {group.email || "No email provided"}
//                                   </Typography>
//                                 </Box>
//                               </Box>

//                               <LightTooltip title="Remove from group">
//                                 <IconButton
//                                   size="small"
//                                   sx={{
//                                     color: "error.main",
//                                     "&:hover": {
//                                       bgcolor: "error.light",
//                                       color: "error.dark",
//                                       transform: 'translateY(-2px)'
//                                     },
//                                   }}
//                                   onClick={() => {
//                                     this.removeMemberFromGroup(group._id);
//                                     this.setState({ adminModalOpen: false });
//                                   }}
//                                 >
//                                   <DeleteIcon />
//                                 </IconButton>
//                               </LightTooltip>
//                             </Box>
//                           </Paper>
//                         </Grid2>
//                       ))}
//                     </Grid2>
//                   ) : (
//                     <Box
//                       sx={{
//                         textAlign: "center",
//                         py: 8,
//                         color: "text.primary",
//                       }}
//                     >
//                       <GroupIcon sx={{ fontSize: 60, opacity: 0.3, mb: 2 }} />
//                       <Typography variant="h6" gutterBottom>
//                         No members in this group
//                       </Typography>
//                       <Typography variant="body2">
//                         Add members from your team list
//                       </Typography>
//                     </Box>
//                   )}
//                 </Box>
//               </Grid2>

//               <Grid2
//                 xs={12}
//                 md={6}
//                 sx={{
//                   height: "100%",
//                   display: "flex",
//                   flexDirection: "column",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     p: 3,
//                     borderBottom: 1,
//                     borderColor: "divider",
//                     bgcolor: "background.default",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <Box>
//                     <Typography variant="h6" fontWeight={600} gutterBottom>
//                       Available Members
//                     </Typography>
//                     <Typography variant="body2" color="text.primary">
//                       Select members to add to group
//                     </Typography>
//                   </Box>

//                   <Button
//                     variant="contained"
//                     size="small"
//                     onClick={this.addMembersToGroup}
//                     disabled={this.state.selectedMembers.length === 0}
//                     startIcon={<PersonAddIcon />}
//                     sx={{
//                       borderRadius: 2,
//                       fontWeight: 600,
//                       px: 3,
//                       background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                       color: 'white',
//                       "&:hover": {
//                         background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
//                         transform: 'translateY(-2px)'
//                       },
//                     }}
//                   >
//                     Add ({this.state.selectedMembers.length})
//                   </Button>
//                 </Box>

//                 <Box
//                   sx={{
//                     flex: 1,
//                     overflowY: "auto",
//                     p: 2,
//                     bgcolor: "background.default",
//                   }}
//                 >
//                   {filterTeam.length > 0 ? (
//                     <Grid2 container spacing={2}>
//                       {filterTeam.map((team) => (
//                         <Grid2 xs={12} key={team.id}>
//                           <Paper
//                             elevation={0}
//                             sx={{
//                               p: 2,
//                               borderRadius: 2,
//                               border: "1px solid",
//                               borderColor: this.state.selectedMembers.includes(
//                                 team.id
//                               )
//                                 ? "primary.main"
//                                 : "divider",
//                               bgcolor: this.state.selectedMembers.includes(
//                                 team.id
//                               )
//                                 ? "primary.lighter"
//                                 : "background.paper",
//                               transition: "all 0.2s",
//                               cursor: "pointer",
//                               "&:hover": {
//                                 borderColor: "primary.main",
//                                 bgcolor: "action.hover",
//                                 transform: 'translateY(-2px)',
//                                 boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
//                               },
//                             }}
//                             onClick={() => {
//                               const isSelected =
//                                 this.state.selectedMembers.includes(team.id);
//                               let selected = [...this.state.selectedMembers];

//                               if (isSelected) {
//                                 selected = selected.filter(
//                                   (id) => id !== team.id
//                                 );
//                               } else {
//                                 selected.push(team.id);
//                               }

//                               this.setState({ selectedMembers: selected });
//                             }}
//                           >
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: 2,
//                               }}
//                             >
//                               <Checkbox
//                                 color="primary"
//                                 checked={this.state.selectedMembers.includes(
//                                   team.id
//                                 )}
//                                 onChange={this.onChangeSelectionBox(team)}
//                                 onClick={(e) => e.stopPropagation()}
//                                 sx={{
//                                   "&.Mui-checked": {
//                                     color: "primary.main",
//                                   },
//                                 }}
//                               />

//                               <Badge
//                                 overlap="circular"
//                                 anchorOrigin={{
//                                   vertical: "bottom",
//                                   horizontal: "right",
//                                 }}
//                                 variant="dot"
//                                 color={
//                                   team.status === "online"
//                                     ? "success"
//                                     : "default"
//                                 }
//                               >
//                                 <Avatar
//                                   sx={{
//                                     bgcolor:
//                                       colors[
//                                         filterTeam.indexOf(team) % colors.length
//                                       ],
//                                     width: 48,
//                                     height: 48,
//                                     fontWeight: 600,
//                                     fontSize: "1.25rem",
//                                     boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
//                                   }}
//                                 >
//                                   {team.name.charAt(0).toUpperCase()}
//                                 </Avatar>
//                               </Badge>

//                               <Box sx={{ flex: 1 }}>
//                                 <Typography
//                                   variant="subtitle1"
//                                   fontWeight={600}
//                                 >
//                                   {team.name || "-"}
//                                 </Typography>
//                                 <Typography
//                                   variant="caption"
//                                   color="text.primary"
//                                 >
//                                   {team.email || "No email provided"}
//                                 </Typography>
//                               </Box>

//                               {this.state.selectedMembers.includes(team.id) && (
//                                 <Chip
//                                   label="Selected"
//                                   color="primary"
//                                   size="small"
//                                   variant="outlined"
//                                   icon={<PersonAddIcon fontSize="small" />}
//                                 />
//                               )}
//                             </Box>
//                           </Paper>
//                         </Grid2>
//                       ))}
//                     </Grid2>
//                   ) : (
//                     <Box
//                       sx={{
//                         textAlign: "center",
//                         py: 8,
//                         color: "text.primary",
//                       }}
//                     >
//                       <PersonIcon sx={{ fontSize: 60, opacity: 0.3, mb: 2 }} />
//                       <Typography variant="h6" gutterBottom>
//                         No team members available
//                       </Typography>
//                       <Typography variant="body2">
//                         Invite team members to get started
//                       </Typography>
//                     </Box>
//                   )}
//                 </Box>
//               </Grid2>
//             </Grid2>
//           </DialogContent>

//           <DialogActions
//             sx={{
//               p: 3,
//               borderTop: 1,
//               borderColor: "divider",
//               justifyContent: "space-between",
//               bgcolor: 'background.default'
//             }}
//           >
//             <Box sx={{ display: "flex", gap: 1 }}>
//               <Chip
//                 icon={<GroupIcon />}
//                 label={`${filterGroup.length} members in group`}
//                 color="primary"
//                 variant="outlined"
//               />
//               <Chip
//                 icon={<PersonIcon />}
//                 label={`${filterTeam.length} available members`}
//                 variant="outlined"
//               />
//             </Box>

//             <Box sx={{ display: "flex", gap: 2 }}>
//               <Button
//                 variant="outlined"
//                 onClick={() => this.setState({ adminModalOpen: false })}
//                 sx={{ borderRadius: 2 }}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 variant="contained"
//                 onClick={this.addMembersToGroup}
//                 disabled={this.state.selectedMembers.length === 0}
//                 startIcon={<PersonAddIcon />}
//                 sx={{ 
//                   borderRadius: 2,
//                   background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                   color: 'white',
//                   "&:hover": {
//                     background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
//                     transform: 'translateY(-2px)'
//                   },
//                 }}
//               >
//                 Add Selected Members
//               </Button>
//             </Box>
//           </DialogActions>
//         </CustomDialog>

//         {/* Shared Group Modal */}
//         <CustomDialog
//           open={sharedModalOpen}
//           onClose={() => this.setState({ sharedModalOpen: false })}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogHeader color={{ main: "#FF9800", dark: "#FF5722" }}>
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 width: '100%'
//               }}
//             >
//               <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                 <GroupIcon fontSize="large" />
//                 <Box>
//                   <Typography variant="h5" fontWeight={700}>
//                     Shared Group Members
//                   </Typography>
//                   <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                     Members in this shared group
//                   </Typography>
//                 </Box>
//               </Box>

//               <IconButton
//                 onClick={() => this.setState({ sharedModalOpen: false })}
//                 sx={{
//                   color: "white !important",
//                   backgroundColor: "#ff4444 !important",
//                   "&:hover": {
//                     backgroundColor: 'rgba(255, 68, 68, 0.2)',
//                   },
//                 }}
//               >
//                 <CloseIcon />
//               </IconButton>
//             </Box>
//           </DialogHeader>
//           <DialogContent dividers sx={{ p: 3 }}>
//             <TextField
//               fullWidth
//               placeholder="Search members..."
//               onChange={this.searchOnChange}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <SearchIcon />
//                   </InputAdornment>
//                 ),
//                 sx: { borderRadius: 2 }
//               }}
//               sx={{ mb: 3 }}
//             />

//             <Box sx={{ maxHeight: "40vh", overflowY: "auto" }}>
//               {filterGroup.length > 0 ? (
//                 filterGroup.map((group) => (
//                   <Paper
//                     key={group._id}
//                     elevation={0}
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 2,
//                       p: 2,
//                       mb: 1.5,
//                       borderRadius: 2,
//                       border: "1px solid",
//                       borderColor: "divider",
//                       "&:hover": { 
//                         bgcolor: "action.hover",
//                         borderColor: "warning.main",
//                         transform: 'translateY(-2px)',
//                         boxShadow: '0 4px 12px rgba(255, 152, 0, 0.1)'
//                       },
//                       transition: 'all 0.2s'
//                     }}
//                   >
//                     <Avatar
//                       sx={{
//                         bgcolor: colors[filterGroup.indexOf(group) % colors.length],
//                         width: 48,
//                         height: 48,
//                         fontWeight: 600,
//                         fontSize: "1.25rem",
//                       }}
//                     >
//                       {group.username.charAt(0).toUpperCase()}
//                     </Avatar>
//                     <Box>
//                       <Typography fontWeight={600} variant="subtitle1">
//                         {group.username}
//                       </Typography>
//                       <Typography variant="caption" color="text.primary">
//                         {group.email || "No email provided"}
//                       </Typography>
//                     </Box>
//                   </Paper>
//                 ))
//               ) : (
//                 <Box sx={{ textAlign: "center", py: 4 }}>
//                   <GroupIcon sx={{ fontSize: 60, opacity: 0.3, mb: 2 }} />
//                   <Typography color="text.primary" variant="h6">
//                     No members found
//                   </Typography>
//                 </Box>
//               )}
//             </Box>
//           </DialogContent>
//           <DialogActions sx={{ p: 2, bgcolor: 'background.default' }}>
//             <Button
//               variant="contained"
//               startIcon={<ExitToAppIcon />}
//               onClick={() => this.leaveGroup()}
//               sx={{
//                 background: 'linear-gradient(135deg, #FF5722 0%, #FF9800 100%)',
//                 color: 'white',
//                 "&:hover": {
//                   background: 'linear-gradient(135deg, #FF9800 0%, #FF5722 100%)',
//                   transform: 'translateY(-2px)'
//                 },
//                 borderRadius: 2,
//               }}
//             >
//               Leave Group
//             </Button>
//             <Button 
//               onClick={() => this.setState({ sharedModalOpen: false })}
//               sx={{ borderRadius: 2 }}
//             >
//               Close
//             </Button>
//           </DialogActions>
//         </CustomDialog>

//         <ReactTour
//           steps={this.state.groups.length > 0 ? stepsone : steps}
//           isOpen={this.state.reactTour}
//           closeTour={() => this.setState({ reactTour: false })}
//         />
//       </Box>
//     );
//   }
// }

// const mapStateToProps = (state) => ({
//   currentUser: state.user.currentUser,
//   features: state.features.features,
// });

// const mapDispatchToProps = (dispatch) => ({
//   setCurrentUser: (user) => dispatch(setCurrentUser(user)),
// });

// export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Myteam));


// import React, { Component } from "react";
// import Loader from "../utils/loader";
// import userService from "../services/userService";
// import teamService from "../services/teamService";
// import Swal from "sweetalert2";
// import TeamCard from "./Cards/Teamcard";
// import { toast, ToastContainer } from "react-toastify";
// import PaginatioN from "react-js-pagination";
// import { paginate } from "../utils/paginate";
// import "./teamMembers.css";
// import Avatars from "./Avatar";
// import team from "../static/noteams.png";
// import isEmptyObject from "../utils/isEmptyObject";
// import { connect } from "react-redux";
// import { setCurrentUser } from "../redux/user/user.actions";
// import { ReactMultiEmail, isEmail } from "react-multi-email";
// import "react-multi-email/style.css";
// import _ from "lodash";
// import ReactTour from "./ReactTour";
// import { withRouter } from "react-router-dom";
// import ChatServices from "../services/ChatServices";
// import BasicAvatar from "./BasicAvatar";
// import { ChatContext } from "../contexts/ChatContext";
// import { addUserLogs } from "../services/userLogServices";
// import SubscriptionRequired from "./SubscriptionRequired";

// // MUI Imports
// import {
//   Box,
//   Card,
//   CardContent,
//   CardActions,
//   TextField,
//   Button,
//   Typography,
//   Divider,
//   Popover,
//   Tooltip,
//   Badge,
//   Avatar,
//   Checkbox,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Chip,
//   Paper,
//   InputAdornment,
//   Fade,
//   Zoom,
// } from "@mui/material";
// import Grid2 from "@mui/material/Unstable_Grid2";
// import {
//   Add as AddIcon,
//   PersonAdd as PersonAddIcon,
//   Search as SearchIcon,
//   Delete as DeleteIcon,
//   Chat as ChatIcon,
//   Group as GroupIcon,
//   ExitToApp as ExitToAppIcon,
//   Close as CloseIcon,
//   HelpOutline as HelpIcon,
//   MoreVert as MoreVertIcon,
//   Person as PersonIcon,
//   ArrowBack as ArrowBackIcon,
//   ArrowForward as ArrowForwardIcon,
//   FirstPage as FirstPageIcon,
//   LastPage as LastPageIcon,
//   Email as EmailIcon,
//   Cancel as CancelIcon,
//   Create as CreateIcon,
//   Badge as BadgeIcon,
// } from "@mui/icons-material";
// import { styled, alpha } from "@mui/material/styles";


// // Styled Components
// const StyledCard = styled(Card)(({ theme }) => ({
//   height: "100%",
//   display: "flex",
//   flexDirection: "column",
//   transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//   borderRadius: 16,
//   overflow: "hidden",
//   "&:hover": {
//     transform: "translateY(-8px)",
//     boxShadow: theme.shadows[12],
//   },
// }));

// const GradientCard = styled(StyledCard)(({ theme }) => ({
//   background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
//   color: theme.palette.primary.contrastText,
// }));

// const SearchTextField = styled(TextField)(({ theme }) => ({
//   "& .MuiOutlinedInput-root": {
//     borderRadius: 50,
//     backgroundColor: alpha(theme.palette.common.white, 0.15),
//     "&:hover": {
//       backgroundColor: alpha(theme.palette.common.white, 0.25),
//     },
//     "&.Mui-focused": {
//       backgroundColor: alpha(theme.palette.common.white, 0.25),
//     },
//   },
// }));

// const ActionButton = styled(Button)(({ theme }) => ({
//   borderRadius: "20px !important",
//   width: "50% !important",
//   textTransform: "none",
//   fontWeight: 600,
//   boxShadow: theme.shadows[2],
//   backgroundColor: "#e7e3e3ff !important",
//   color: "#667eea !important",
//   "&:hover": {
//     boxShadow: theme.shadows[6],
//     backgroundColor: "#c6c3c3ff !important",
//   },
// }));

// // Dialog Styled Components
// const CustomDialog = styled(Dialog)(({ theme }) => ({
//   "& .MuiPaper-root": {
//     borderRadius: 20,
//     overflow: "hidden",
//     background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.secondary.main, 0.05)} 100%)`,
//   },
// }));

// const DialogHeader = styled(DialogTitle)(({ theme, color }) => ({
//   background: `linear-gradient(135deg, ${color?.main || theme.palette.primary.main} 0%, ${color?.dark || theme.palette.primary.dark} 100%)`,
//   color: theme.palette.primary.contrastText,
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   padding: theme.spacing(2.5, 3),
//   position: "relative",
//   "&:after": {
//     content: '""',
//     position: "absolute",
//     bottom: 0,
//     left: "5%",
//     width: "90%",
//     height: "2px",
//     background: `linear-gradient(90deg, transparent, ${alpha(theme.palette.primary.contrastText, 0.3)}, transparent)`,
//   },
// }));

// const colors = [
//   "#bff603",
//   "yellow",
//   "#80d4ff",
//   "orange",
//   "#ff8b94",
//   "#d3ffce",
//   "#9bb7d4",
//   "#ffdb58",
//   "#f1a7fe",
//   "#ff6961",
//   "#ffb347",
//   "#add8e6",
//   "#a0bfe6",
//   "#89cff0",
//   "#4f86f7",
//   "#67e6ec",
//   "#7fffd4",
//   "#77dd77",
//   "#b19cd9",
//   "#ff9999",
// ];

// const steps = [
//   {
//     selector: ".first-step",
//     content: "Create new group to add members",
//     position: "left",
//   },
//   {
//     selector: ".second-step",
//     content: "Enter email to send invite request to member",
//     position: "bottom",
//   },
// ];

// const stepsone = [
//   {
//     selector: ".first-step",
//     content: "Create new group to add members",
//     position: "left",
//   },
//   {
//     selector: ".second-step",
//     content: "Enter email to send invite request to member",
//     position: "bottom",
//   },
//   {
//     selector: ".third-step",
//     content: "Click to view/add members to the group",
//     position: "bottom",
//   },
// ];

// class Myteam extends Component {
//   state = {
//     loading: true,
//     userProfile: "",
//     inviteEmail: "",
//     inviteEmails: [],
//     teamMembers: [],
//     totalMemberCount: "",
//     currentPage: 1,
//     pageSize: 8,
//     searchQuery: "",
//     groups: [],
//     otherGroups: [],
//     groupMembers: [],
//     groupMemberIDs: [],
//     groupName: "",
//     groupId: "",
//     colorID: 0,
//     back: [],
//     color: ["#bff603", "yellow", "#80d4ff", "orange"],
//     filterTeam: [],
//     filterGroup: [],
//     filterGroupName: [],
//     filterOtherGroup: [],
//     selectedMembers: [],
//     userFeatures: {},
//     myGroupPage: 1,
//     otherGroupPage: 1,
//     reactTour: false,
//     subReqOpen: false,
//     inviteAnchorEl: null,
//     groupAnchorEl: null,
//     adminModalOpen: false,
//     sharedModalOpen: false,
//     inviteModalOpen: false,
//     createGroupModalOpen: false, // Changed from popover to modal
//   };

//   static contextType = ChatContext;

//   // ... (keep all existing methods exactly as they are, including:)
//   // searchOnChange, handleSearch, componentDidMount, componentDidUpdate,
//   // getProfile, getOtherGroups, getTeam, getGroup, handleDelete,
//   // handlePageChange, handleSendInvite, handleGroupName, sendInvite,
//   // setGroup, createGroup, onChangeSelectionBox, addMembersToGroup,
//   // removeMemberFromGroup, leaveGroup, deleteGroup, getPagedData,
//   // handleOpenChat, handleOpenGroupChat

//   searchOnChange = (e) => {
//     if (e.target.value === "") {
//       this.setState({
//         filterTeam: this.state.teamMembers,
//         filterGroup: this.state.groupMembers,
//       });
//     } else {
//       let value = e.target.value;
//       let teamMembers = this.state.teamMembers;
//       let groupMembers = this.state.groupMembers;
//       let result2 = [];
//       let result1 = [];
//       result1 = teamMembers.filter((member) => {
//         if (member.name.toLowerCase().search(value.toLowerCase()) !== -1) {
//           return member;
//         }
//       });
//       result2 = groupMembers.filter((group) => {
//         if (group.username.toLowerCase().search(value.toLowerCase()) !== -1) {
//           return group;
//         }
//       });

//       this.setState({ filterTeam: result1, filterGroup: result2 });
//     }
//   };

//   handleSearch = (e) => {
//     if (e.target.value === "") {
//       this.setState({
//         filterTeam: this.state.teamMembers,
//         filterGroupName: this.state.groups,
//         filterOtherGroup: this.state.otherGroups,
//       });
//     } else {
//       let value = e.target.value;
//       let teamMembers = this.state.teamMembers;
//       let groups = this.state.groups;
//       let otherGroups = this.state.otherGroups;

//       let result1 = teamMembers.filter((member) => {
//         if (member.name.toLowerCase().indexOf(value.toLowerCase()) > -1) {
//           return member;
//         }
//       });

//       let result2 = groups.filter((groupmember) => {
//         if (groupmember.name.toLowerCase().indexOf(value.toLowerCase()) > -1) {
//           return groupmember;
//         }
//       });

//       let result3 = otherGroups.filter((othergroupmember) => {
//         if (
//           othergroupmember.name.toLowerCase().indexOf(value.toLowerCase()) > -1
//         ) {
//           return othergroupmember;
//         }
//       });

//       this.setState({
//         filterTeam: result1,
//         filterGroupName: result2,
//         filterOtherGroup: result3,
//       });
//     }
//   };

//   async componentDidMount() {
//     setTimeout(() => {
//       if (this.props.hasAccess === false) {
//         this.setState({ subReqOpen: true, loading: false });
//       } else {
//         this.getTeam();
//       }
//     }, 2000);
//   }

//   async componentDidUpdate(prevProps, prevState) {
//     if (prevState.groupId !== this.state.groupId) {
//       this.setState({ selectedMembers: [] });
//     }
//   }

//   getProfile = async () => {
//     let user;
//     const { currentUser, setCurrentUser, features } = this.props;
//     if (currentUser && !isEmptyObject(currentUser)) {
//       user = await userService.getProfile();
//       user = user.data;
//     } else {
//       user = await userService.getProfile();
//       user = user.data;
//       setCurrentUser(user);
//     }
//     this.setState({ userProfile: user, userFeatures: features }, () => {
//       this.getOtherGroups();
//     });
//   };

//   getOtherGroups = async () => {
//     let other = this.state.userProfile.groups;

//     if (other.length > 0) {
//       const othergroups = await teamService.getGroupById(other);
//       this.setState({
//         otherGroups: othergroups.data,
//         filterOtherGroup: othergroups.data,
//       });
//     } else {
//       this.setState({ otherGroups: [] });
//     }
//     this.setState({ loading: false });
//   };

//   getTeam = async () => {
//     const teamMembers = await userService.getTeam();
//     if (teamMembers.status !== 200) {
//       this.setState({ teamMembers: [], filterTeam: [] }, () => {
//         this.getGroup();
//       });
//     } else {
//       this.setState(
//         {
//           filterTeam: teamMembers.data.user,
//           teamMembers: teamMembers.data.user,
//           totalMemberCount: teamMembers.data.user.length,
//         },
//         () => {
//           this.getGroup();
//         },
//       );
//     }
//   };

//   getGroup = async () => {
//     const group = await teamService.getAllGroups();
//     if (group.status === 200) {
//       this.setState({ groups: group.data, filterGroupName: group.data }, () => {
//         this.getProfile();
//       });
//     } else {
//       this.getProfile();
//     }
//   };

//   handleDelete = async (user) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: `Do you want to remove this team member`,
//       type: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, delete it!",
//       cancelButtonText: "No, keep it",
//     }).then(async (result) => {
//       if (result.value === true) {
//         this.setState({ loading: true });
//         let data = { id: user.id };
//         const team = await userService.deleteTeam(data);

//         if (team.status === 200) {
//           this.getTeam();
//           Swal.fire("Deleted!", `${team.message}`, "success");
//           const data = {
//             userId: sessionStorage.getItem("userId"),
//             organizationId: sessionStorage.getItem("organizationId"),
//             actionType: "deleteTeamMember",
//             userEmail: user.email,
//           };
//           const addLogs = await addUserLogs(data);
//           if (addLogs.status !== 200) {
//             toast.error(addLogs.message);
//           }
//         } else {
//           this.setState({ loading: false });
//           Swal.fire("Cancelled", `${team.message}`, "error");
//         }
//       } else {
//         Swal.fire("Cancelled", "Your team member is safe :)", "error");
//       }
//     });
//   };

//   handlePageChange = (page) => {
//     this.setState({ currentPage: page });
//   };

//   handleSendInvite = (e) => {
//     this.setState({
//       [e.target.name]: e.target.value,
//     });
//   };

//   handleGroupName = (e) => {
//     this.setState({
//       [e.target.name]: e.target.value,
//     });
//   };

//   sendInvite = async (e) => {
//     if (this.state.userFeatures?.TeamManagement === false) {
//       toast("Please upgrade your plan to enable team member features");
//       return;
//     }
//     this.setState({ loading: true });
//     e.preventDefault();
//     let email = this.state.inviteEmails;
//     if (email.length < 1) {
//       this.setState({ loading: false });
//       toast.error("Please enter valid email !");
//     } else {
//       const team = await teamService.inviteMember(email);
//       if (team.status !== 200) {
//         this.setState({ loading: false });
//         toast.error(team.message);
//       } else {
//         this.setState({ loading: false, inviteModalOpen: false });
//         toast.success(team.message);

//         const data = {
//           userId: sessionStorage.getItem("userId"),
//           organizationId: sessionStorage.getItem("organizationId"),
//           actionType: "inviteUser",
//           userEmail: email,
//         };
//         const addLogs = await addUserLogs(data);
//         if (addLogs.status !== 200) {
//           toast.error(addLogs.message);
//         }
//       }
//     }
//     this.setState({ inviteEmails: [] });
//   };

//   setGroup = async (groupid, groupmembers) => {
//     let team = this.state.filterTeam;
//     this.setState(
//       {
//         filterTeam: [],
//         groupMembers: [],
//         filterGroup: [],
//         groupId: groupid,
//         loading: true,
//       },
//       () => this.setState({ filterTeam: team }),
//     );

//     if (groupmembers.length > 0) {
//       const groupdata = await teamService.getGroupMembers(groupmembers);
//       if (groupdata.status === 200) {
//         this.setState({
//           groupMembers: groupdata.data,
//           filterGroup: groupdata.data,
//         });
//       }
//     }
//     this.setState({ loading: false, groupMemberIDs: groupmembers });
//   };

//   createGroup = async (e) => {
//     e.preventDefault();
//     if (this.state.userFeatures?.TeamManagement === false) {
//       toast("Please upgrade your plan to enable team member features");
//       return;
//     }

//     this.setState({ loading: true });
//     let currentGroup = this.state.groups;
//     let groupName = this.state.groupName;
//     let userProfile = this.state.userProfile;
//     let match = 0;

//     if (groupName === "") {
//       this.setState({ loading: false });
//       toast.error(`Invalid Group Name!`);
//       return;
//     }

//     if (currentGroup.length > 0) {
//       for (let i = 0; i < currentGroup.length; i++) {
//         if (groupName === currentGroup[i].name) {
//           this.setState({ loading: false, groupName: "" });
//           toast(`${groupName} Already exists!`);
//           match = 1;
//           return;
//         }
//       }
//     }

//     if (match === 0) {
//       let data = {
//         groupname: groupName,
//         ownerName: userProfile.username,
//       };
//       const team = await teamService.createGroup(data);
//       if (team.status === 200) {
//         this.getGroup();
//         toast.success(team.message);
//         this.setState({ createGroupModalOpen: false });
//         const data = {
//           userId: sessionStorage.getItem("userId"),
//           organizationId: sessionStorage.getItem("organizationId"),
//           actionType: "createGroup",
//         };
//         const addLogs = await addUserLogs(data);
//         if (addLogs.status !== 200) {
//           toast.error(addLogs.message);
//         }
//       } else {
//         this.setState({ loading: false });
//         toast.error(team.message);
//       }
//     }

//     this.setState({ groupName: "" });
//   };

//   onChangeSelectionBox = (team) => (e) => {
//     let selected = this.state.selectedMembers;
//     if (e.target.checked === true) {
//       selected.push(team.id);
//     } else {
//       selected.splice(selected.indexOf(team.id), 1);
//     }
//     this.setState({ selectedMembers: selected });
//   };

//   addMembersToGroup = async () => {
//     let groupMembers = this.state.groupMemberIDs;
//     let selectedMembers = this.state.selectedMembers;

//     if (selectedMembers.length < 1) {
//       toast("No Member selected");
//       return;
//     } else {
//       let presents = _.intersectionWith(
//         groupMembers,
//         selectedMembers,
//         _.isEqual,
//       );
//       if (presents.length > 0) {
//         for (let i = 0; i < presents.length; i++) {
//           selectedMembers.splice(selectedMembers.indexOf(presents[i]), 1);
//         }
//       }
//     }

//     if (selectedMembers.length > 0) {
//       let data = {
//         memberArray: selectedMembers,
//         groupID: this.state.groupId,
//       };

//       const res = await teamService.addMemberToGroup(data);
//       if (res.status === 200) {
//         this.getGroup();
//         toast.success(res.message);
//         this.setState({ adminModalOpen: false });
//       } else {
//         toast.error(res.message);
//       }
//       this.setState({ selectedMembers: [] });
//       return;
//     } else {
//       toast("Member already exists");
//       return;
//     }
//   };

//   removeMemberFromGroup = async (id) => {
//     let data = {
//       memberID: id,
//       groupID: this.state.groupId,
//     };

//     const res = await teamService.removeMemberFromGroup(data);
//     if (res.status === 200) {
//       this.getGroup();
//       toast.success(res.message);
//     } else {
//       toast.error(res.message);
//     }
//   };

//   leaveGroup = async () => {
//     this.setState({ loading: true, sharedModalOpen: false });
//     let data = {
//       _id: this.state.groupId,
//     };
//     const response = await teamService.leaveGroup(data);
//     if (response.status === 200) {
//       this.getProfile();
//       toast.success(response.message);
//     } else {
//       toast.error(response.message);
//       this.setState({ loading: false });
//     }
//   };

//   deleteGroup = async (group) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: `Do you want to delete ${group.name}`,
//       type: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, delete it!",
//       cancelButtonText: "No, keep it",
//     }).then(async (result) => {
//       if (result.value === true) {
//         this.setState({ loading: true });
//         let data = {
//           _id: group._id,
//           members: group.members,
//         };

//         const response = await teamService.deleteGroup(data);
//         if (response.status === 200) {
//           this.getGroup();
//           Swal.fire("Deleted!", `${response.message}`, "success");
//           const data = {
//             userId: sessionStorage.getItem("userId"),
//             organizationId: sessionStorage.getItem("organizationId"),
//             actionType: "deleteGroup",
//           };
//           const addLogs = await addUserLogs(data);
//           if (addLogs.status !== 200) {
//             toast.error(addLogs.message);
//           }
//         } else {
//           this.setState({ loading: false });
//           Swal.fire("Cancelled", `${response.message}`, "error");
//         }
//       } else {
//         Swal.fire("Cancelled", "Your Group is safe :)", "error");
//       }
//     });
//   };

//   getPagedData = () => {
//     let {
//       teamMembers,
//       currentPage,
//       pageSize,
//       searchQuery,
//       filterGroupName,
//       filterOtherGroup,
//     } = this.state;

//     let filteredMembers = teamMembers;

//     if (searchQuery) {
//       filteredMembers = teamMembers.filter((team) =>
//         team.name.toLowerCase().startsWith(searchQuery.toLowerCase()),
//       );
//       filterGroupName = filterGroupName.filter((team) =>
//         team.name.toLowerCase().startsWith(searchQuery.toLowerCase()),
//       );
//       filterOtherGroup = filterOtherGroup.filter((team) =>
//         team.name.toLowerCase().startsWith(searchQuery.toLowerCase()),
//       );
//     }

//     const team = paginate(filteredMembers, currentPage, pageSize);
//     const myGroups = paginate(filterGroupName, this.state.myGroupPage, 9);
//     const otherGroups = paginate(
//       filterOtherGroup,
//       this.state.otherGroupPage,
//       9,
//     );

//     return {
//       totalMemberCount: filteredMembers.length,
//       teamMembers: team,
//       myGroups: myGroups,
//       paginateOtherGroups: otherGroups,
//       myGroupsCount: filterGroupName.length,
//       otherGroupsCount: filterOtherGroup.length,
//     };
//   };

//   handleOpenChat = async (id) => {
//     var userProfile = this.state.userProfile;
//     try {
//       const response = await ChatServices.createContact(userProfile._id, id);
//       if (response.status === 200) {
//         const { history } = this.props;
//         history.push({
//           pathname: `/chat`,
//         });
//       }
//     } catch (error) {
//       console.error("Error calling backend API:", error.message);
//     }
//   };

//   handleOpenGroupChat = async (groupName, selectedContacts, groupId) => {
//     try {
//       if (!this.props.hasAccessToChat) {
//         this.setState({ subReqOpen: true });
//         return;
//       }
//       const response = await ChatServices.createGroup(
//         groupName,
//         selectedContacts,
//         groupId,
//       );
//       if (response.status === 200) {
//         const { history } = this.props;
//         history.push({
//           pathname: `/chat`,
//         });
//       }
//     } catch (error) {
//       console.error("Error calling backend API:", error.message);
//     }
//   };

//   // Custom Email Chip Component
//   EmailChip = ({ email, index, removeEmail }) => (
//     <Chip
//       key={index}
//       label={email}
//       onDelete={() => removeEmail(index)}
//       deleteIcon={<CancelIcon />}
//       size="medium"
//       color="primary"
//       variant="outlined"
//       sx={{
//         m: 0.5,
//         backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
//         borderColor: (theme) => alpha(theme.palette.primary.main, 0.3),
//         "& .MuiChip-deleteIcon": {
//           color: (theme) => theme.palette.error.main,
//           "&:hover": {
//             color: (theme) => theme.palette.error.dark,
//           },
//         },
//       }}
//     />
//   );

//   render() {
//     let {
//       filterTeam,
//       filterGroup,
//       filterGroupName,
//       filterOtherGroup,
//       subReqOpen,
//       adminModalOpen,
//       sharedModalOpen,
//       inviteModalOpen,
//       createGroupModalOpen,
//       inviteEmails,
//       groupName,
//     } = this.state;

//     let {
//       teamMembers,
//       totalMemberCount,
//       myGroups,
//       paginateOtherGroups,
//       myGroupsCount,
//       otherGroupsCount,
//     } = this.getPagedData();

//     return (
//       <Box sx={{ p: 3, bgcolor: "#f5f5f5", minHeight: "100vh" }}>
//              <Loader loading={this.state.loading} />
//         <SubscriptionRequired
//           open={subReqOpen}
//           setOpen={(val) => this.setState({ subReqOpen: val })}
//         />
//         <ToastContainer />

//         <div
//           style={{
//             height: "10vh",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           <h2
//             style={{
//               color: "#012a83",
//               fontSize: "15px",
//               fontWeight: "100",
//               fontstyle: "bold",
//               letterSpacing: "2px",
//               margin: 0,
//             }}
//           >
//             TEAM WORKSPACE
//           </h2>
//         </div>

//         {/* Header Section */}
//         <Paper
//           elevation={0}
//           sx={{
//             p: 3,
//             mb: 3,
//             borderRadius: 3,
//             background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//             position: "relative",
//             overflow: "hidden",
//             "&:before": {
//               content: '""',
//               position: "absolute",
//               top: -50,
//               right: -50,
//               width: 150,
//               height: 150,
//               background: "rgba(255,255,255,0.1)",
//               borderRadius: "50%",
//             },
//           }}
//         >
//           <Grid2 container spacing={2} alignItems="center">
//             <Grid2 xs={12} md={6}>
//               <SearchTextField
//                 fullWidth
//                 placeholder="Search groups or team members..."
//                 onChange={this.handleSearch}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <SearchIcon sx={{ color: "white" }} />
//                     </InputAdornment>
//                   ),
//                   sx: {
//                     color: "white",
//                     background: "rgba(255,255,255,0.1) !important",
//                     "& .MuiOutlinedInput-notchedOutline": {
//                       borderColor: "rgba(255,255,255,0.3) !important",
//                     },
//                     "&:hover .MuiOutlinedInput-notchedOutline": {
//                       borderColor: "rgba(255,255,255,0.5) !important",
//                     },
//                     "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                       borderColor: "white !important",
//                     },
//                   },
//                 }}
//               />
//             </Grid2>

//             <Grid2 xs={12} md={6}>
//               <Box
//                 sx={{
//                   display: "flex",
//                   gap: 2,
//                   justifyContent: { xs: "flex-start", md: "flex-end" },
//                 }}
//               >
//                 <ActionButton
//                   className="first-step"
//                   variant="contained"
//                   startIcon={<AddIcon />}
//                   onClick={() => this.setState({ createGroupModalOpen: true })}
//                   sx={{
//                     background:
//                       "linear-gradient(135deg, #fff 0%, #f5f5f5 100%) !important",
//                     color: "#667eea !important",
//                     "&:hover": {
//                       background:
//                         "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%) !important",
//                       transform: "translateY(-2px)",
//                     },
//                   }}
//                 >
//                   Create Group
//                 </ActionButton>

//                 <ActionButton
//                   className="second-step"
//                   variant="contained"
//                   startIcon={<PersonAddIcon />}
//                   onClick={() => this.setState({ inviteModalOpen: true })}
//                   sx={{
//                     background:
//                       "linear-gradient(135deg, #fff 0%, #f5f5f5 100%) !important",
//                     color: "#667eea !important",
//                     "&:hover": {
//                       background:
//                         "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%) !important",
//                       transform: "translateY(-2px)",
//                     },
//                   }}
//                 >
//                   Invite
//                 </ActionButton>

//                 <Tooltip title="Need Help?">
//                   <IconButton
//                     onClick={() => this.setState({ reactTour: true })}
//                     sx={{
//                       background:
//                         "linear-gradient(135deg, #fff 0%, #f5f5f5 100%) !important",
//                       color: "#4762d8 !important",
//                       "&:hover": {
//                         background:
//                           "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%) !important",
//                         transform: "translateY(-2px)",
//                       },
//                       width: 48,
//                       height: 48,
//                     }}
//                   >
//                     <HelpIcon />
//                   </IconButton>
//                 </Tooltip>
//               </Box>
//             </Grid2>
//           </Grid2>
//         </Paper>

//         {/* Create Group Modal */}
//         <CustomDialog
//           open={createGroupModalOpen}
//           onClose={() =>
//             this.setState({ createGroupModalOpen: false, groupName: "" })
//           }
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogHeader color={{ main: "#667eea", dark: "#764ba2" }}>
//             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//               <CreateIcon fontSize="large" />
//               <Box>
//                 <Typography variant="h5" fontWeight={700}>
//                   Create New Group
//                 </Typography>
//                 <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                   Organize team members into groups
//                 </Typography>
//               </Box>
//             </Box>
//             {/* <IconButton
//               onClick={() => this.setState({ createGroupModalOpen: false, groupName: "" })}
//               sx={{
//                 color: "white !important",
//                 backgroundColor: "#ff4444 !important",
//                 '&:hover': {
//                   backgroundColor: 'rgba(255, 68, 68, 0.2)',
//                 }
//               }}
//               size="small"
//             >
//               <CloseIcon />
//             </IconButton> */}
//           </DialogHeader>

//           <DialogContent sx={{ p: 3, pt: 4 }}>
//             <form onSubmit={this.createGroup}>
//               <Box sx={{ mb: 1, mt: 2 }}>
//                 <TextField
//                   fullWidth
//                   placeholder="Enter group name"
//                   name="groupName"
//                   value={groupName}
//                   onChange={this.handleGroupName}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <BadgeIcon sx={{ color: "primary.main" }} />
//                       </InputAdornment>
//                     ),
//                     sx: {
//                       borderRadius: 2,
//                       "& .MuiOutlinedInput-input": {
//                         padding: "12px 14px",
//                       },
//                     },
//                   }}
//                   helperText="Choose a unique name for your group"
//                   FormHelperTextProps={{
//                     sx: { ml: 0, mt: 1 },
//                   }}
//                 />
//               </Box>

//               {/* <Box sx={{ 
//                 backgroundColor: (theme) => alpha(theme.palette.info.main, 0.1),
//                 borderRadius: 2,
//                 p: 1,
//                 mb: 1
//               }}>
//                 <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                   <HelpIcon fontSize="small" />
//                   You can add members to this group after creation
//                 </Typography>
//               </Box> */}

//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 2,
//                   backgroundColor: (theme) =>
//                     alpha(theme.palette.primary.main, 0.05),
//                   p: 2,
//                   borderRadius: 2,
//                   border: (theme) =>
//                     `1px dashed ${alpha(theme.palette.primary.main, 0.3)}`,
//                 }}
//               >
//                 <GroupIcon color="primary" />
//                 <Box>
//                   <Typography variant="body2" fontWeight={500} color="primary">
//                     Group Benefits
//                   </Typography>
//                   <Typography variant="caption" color="text.primary">
//                     • Organized collaboration • Group chats • Shared resources
//                   </Typography>
//                 </Box>
//               </Box>
//             </form>
//           </DialogContent>

//           <DialogActions sx={{ p: 3, borderTop: 1, borderColor: "divider" }}>
//             <Button
//               onClick={() =>
//                 this.setState({ createGroupModalOpen: false, groupName: "" })
//               }
//               sx={{ borderRadius: 2 }}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="contained"
//               onClick={this.createGroup}
//               disabled={!groupName.trim()}
//               startIcon={<CreateIcon />}
//               sx={{
//                 background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                 color: "white !important",
//                 "&:hover": {
//                   background:
//                     "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
//                   color: "white !important",
//                 },
//                 minWidth: "150px",
//                 minHeight: "35px",
//                 borderRadius: 2,
//               }}
//             >
//               Create Group
//             </Button>
//           </DialogActions>
//         </CustomDialog>

//         {/* Improved Invite Team Members Modal */}
//         <CustomDialog
//           open={inviteModalOpen}
//           onClose={() =>
//             this.setState({ inviteModalOpen: false, inviteEmails: [] })
//           }
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogHeader color={{ main: "#667eea", dark: "#764ba2" }}>
//             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//               <EmailIcon fontSize="large" />
//               <Box>
//                 <Typography variant="h5" fontWeight={700}>
//                   Invite Team Members
//                 </Typography>
//                 <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                   Send email invitations to collaborate
//                 </Typography>
//               </Box>
//             </Box>
//             {/* <IconButton
//               onClick={() => this.setState({ inviteModalOpen: false, inviteEmails: [] })}
//               sx={{
//                 color: "white !important",
//                 backgroundColor: "#ff4444 !important",
//                 '&:hover': {
//                   backgroundColor: 'rgba(255, 68, 68, 0.2)',
//                 }
//               }}
//               size="small"
//             >
//               <CloseIcon />
//             </IconButton> */}
//           </DialogHeader>

//           <DialogContent sx={{ p: 3 }}>
//             <Box sx={{ mb: 1, pt: 3 }}>
//               <ReactMultiEmail
//                 placeholder="Enter email addresses..."
//                 emails={inviteEmails}
//                 onChange={(_emails) => {
//                   this.setState({ inviteEmails: _emails });
//                 }}
//                 validateEmail={(email) => isEmail(email)}
//                 getLabel={(email, index, removeEmail) => (
//                   <this.EmailChip
//                     email={email}
//                     index={index}
//                     removeEmail={removeEmail}
//                   />
//                 )}
//                 inputProps={{
//                   style: {
//                     width: "100%",
//                     border: "none",
//                     outline: "none",
//                     padding: "8px 0",
//                     fontSize: "16px",
//                     backgroundColor: "transparent",
//                   },
//                 }}
//               />

//               {inviteEmails.length > 0 && (
//                 <Box
//                   sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1 }}
//                 >
//                   <Typography variant="caption" color="text.primary">
//                     {inviteEmails.length} email
//                     {inviteEmails.length !== 1 ? "s" : ""} added
//                   </Typography>
//                   <Chip
//                     label="Clear All"
//                     size="small"
//                     onClick={() => this.setState({ inviteEmails: [] })}
//                     sx={{
//                       cursor: "pointer",
//                       backgroundColor: "error.main",
//                       color: "white",
//                       "&:hover": {
//                         backgroundColor: "error.dark",
//                       },
//                     }}
//                   />
//                 </Box>
//               )}
//             </Box>

//             <Box
//               sx={{
//                 backgroundColor: (theme) => alpha(theme.palette.info.main, 0.1),
//                 borderRadius: 2,
//                 p: 1,
//               }}
//             >
//               <Typography
//                 variant="body2"
//                 color="text.primary"
//                 sx={{ display: "flex", alignItems: "center", gap: 1 }}
//               >
//                 <HelpIcon fontSize="small" />
//                 *Multiple invites can be sent
//               </Typography>
//             </Box>
//           </DialogContent>

//           <DialogActions sx={{ p: 3, borderTop: 1, borderColor: "divider" }}>
//             <Button
//               onClick={() =>
//                 this.setState({ inviteModalOpen: false, inviteEmails: [] })
//               }
//               sx={{ borderRadius: 2 }}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="contained"
//               onClick={this.sendInvite}
//               disabled={inviteEmails.length === 0}
//               startIcon={<PersonAddIcon />}
//               sx={{
//                 background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                 color: "white !important",
//                 "&:hover": {
//                   background:
//                     "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
//                   color: "white !important",
//                 },
//                 minWidth: "150px",
//                 minHeight: "35px",
//                 borderRadius: 2,
//               }}
//             >
//               Send Invites ({inviteEmails.length})
//             </Button>
//           </DialogActions>
//         </CustomDialog>

//         {/* Empty State */}
//         {teamMembers.length === 0 &&
//         this.state.groups.length === 0 &&
//         this.state.otherGroups.length === 0 ? (
//           <Box sx={{ textAlign: "center", py: 8 }}>
//             <img
//               src={team}
//               alt="No teams"
//               style={{ maxWidth: "400px", opacity: 0.7 }}
//             />
//             <Typography variant="h5" color="text.primary" sx={{ mt: 3 }}>
//               No teams or groups yet
//             </Typography>
//             <Typography variant="body2" color="text.primary" sx={{ mt: 1 }}>
//               Create a group or invite team members to get started
//             </Typography>
//           </Box>
//         ) : (
//           <>
//             {/* Team Members Section */}
//             {teamMembers.length > 0 && (
//               <Fade in timeout={800}>
//                 <Box sx={{ mb: 4 }}>
//                   <Typography
//                     variant="h5"
//                     fontWeight={600}
//                     gutterBottom
//                     sx={{ mb: 3, display: "flex", alignItems: "center" }}
//                   >
//                     <Box
//                       sx={{
//                         width: 4,
//                         height: 24,
//                         background:
//                           "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                         borderRadius: 2,
//                         mr: 2,
//                       }}
//                     />
//                     <GroupIcon
//                       sx={{
//                         mr: 1,
//                         verticalAlign: "middle",
//                         color: "primary.main",
//                       }}
//                     />
//                     Team Members
//                     <Chip
//                       label={`${teamMembers.length} members`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ ml: 2 }}
//                     />
//                   </Typography>
//                   <Grid2 container spacing={2}>
//                     {filterTeam.map((team) => (
//                       <Grid2 xs={12} sm={6} md={4} lg={3} key={team.id}>
//                         <TeamCard
//                           teamdata={team}
//                           grpData={this.state.groups}
//                           deleteMember={() => this.handleDelete(team)}
//                           openChat={() => this.handleOpenChat(team?.id)}
//                         />
//                       </Grid2>
//                     ))}
//                   </Grid2>

//                   {totalMemberCount > 8 && (
//                     <Box
//                       sx={{ display: "flex", justifyContent: "center", mt: 3 }}
//                     >
//                       <PaginatioN
//                         activePage={this.state.currentPage}
//                         itemsCountPerPage={this.state.pageSize}
//                         totalItemsCount={totalMemberCount}
//                         pageRangeDisplayed={3}
//                         onChange={this.handlePageChange}
//                         itemClass="page-item"
//                         linkClass="page-link"
//                       />
//                     </Box>
//                   )}
//                 </Box>
//               </Fade>
//             )}

//             {/* My Groups Section */}
//             {this.state.groups.length > 0 && (
//               <Fade in timeout={1000}>
//                 <Box sx={{ mb: 4 }}>
//                   <Typography
//                     variant="h5"
//                     fontWeight={600}
//                     gutterBottom
//                     sx={{ mb: 3, display: "flex", alignItems: "center" }}
//                   >
//                     <Box
//                       sx={{
//                         width: 4,
//                         height: 24,
//                         background:
//                           "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                         borderRadius: 2,
//                         mr: 2,
//                       }}
//                     />
//                     <GroupIcon
//                       sx={{
//                         mr: 1,
//                         verticalAlign: "middle",
//                         color: "primary.main",
//                       }}
//                     />
//                     My Groups
//                     <Chip
//                       label={`${myGroupsCount} Groups`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ ml: 2, fontWeight: 500 }}
//                     />
//                   </Typography>
//                   <Grid2 container spacing={3}>
//                     {filterGroupName.length > 0 &&
//                       myGroups.map((group, index) => (
//                         <Grid2 xs={12} sm={4} md={2} lg={3} key={group._id}>
//                           <Zoom in timeout={300 + index * 100}>
//                             <StyledCard className="third-step">
//                               {/* Card Header with Gradient */}
//                               <Box
//                                 sx={{
//                                   background:
//                                     "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                                   py: 1.5,
//                                   textAlign: "center",
//                                   position: "relative",
//                                   "&:hover": {
//                                     background:
//                                       "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
//                                   },
//                                 }}
//                               >
//                                 <Box
//                                   onClick={() =>
//                                     this.setGroup(group._id, group.members)
//                                   }
//                                   sx={{ cursor: "pointer" }}
//                                 >
//                                   <Box
//                                     sx={{
//                                       display: "inline-flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                       width: 50,
//                                       height: 50,
//                                       borderRadius: "50%",
//                                       bgcolor: "rgba(255,255,255,0.2)",
//                                       border: "3px solid rgba(255,255,255,0.3)",
//                                       transition: "all 0.3s",
//                                       "&:hover": {
//                                         transform: "scale(1.1)",
//                                         boxShadow:
//                                           "0 0 20px rgba(255,255,255,0.3)",
//                                       },
//                                     }}
//                                   >
//                                     <Typography
//                                       variant="h5"
//                                       fontWeight={700}
//                                       color="white"
//                                     >
//                                       {group.name.charAt(0).toUpperCase()}
//                                     </Typography>
//                                   </Box>
//                                 </Box>
//                               </Box>

//                               <CardContent sx={{ flexGrow: 1, pt: 2 }}>
//                                 {/* Group Name */}
//                                 <Typography
//                                   variant="h6"
//                                   fontWeight={600}
//                                   sx={{
//                                     mb: 1,
//                                     overflow: "hidden",
//                                     textOverflow: "ellipsis",
//                                     whiteSpace: "nowrap",
//                                   }}
//                                   title={group.name}
//                                 >
//                                   {group.name}
//                                 </Typography>

//                                 {/* Admin Info */}
//                                 <Box
//                                   sx={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     mb: 2,
//                                   }}
//                                 >
//                                   <PersonIcon
//                                     fontSize="small"
//                                     sx={{ mr: 0.5, color: "text.primary" }}
//                                   />
//                                   <Typography
//                                     variant="body2"
//                                     color="text.primary"
//                                   >
//                                     Admin:{" "}
//                                     <span
//                                       style={{
//                                         fontWeight: 500,
//                                         color: "primary.main",
//                                       }}
//                                     >
//                                       {this.state.userProfile.username}
//                                     </span>
//                                   </Typography>
//                                 </Box>

//                                 {/* Members Count */}
//                                 <Chip
//                                   icon={<GroupIcon fontSize="small" />}
//                                   label={`${group.members.length} ${
//                                     group.members.length === 1
//                                       ? "member"
//                                       : "members"
//                                   }`}
//                                   size="small"
//                                   variant="outlined"
//                                   sx={{ mb: 1 }}
//                                 />
//                               </CardContent>

//                               {/* Action Buttons */}
//                               <CardActions
//                                 sx={{
//                                   p: 1.5,
//                                   bgcolor: "background.default",
//                                   borderTop: "1px solid",
//                                   borderColor: "divider",
//                                 }}
//                               >
//                                 <Box
//                                   sx={{
//                                     display: "flex",
//                                     justifyContent: "space-between",
//                                     width: "100%",
//                                   }}
//                                 >
//                                   {/* Chat Button */}
//                                   <Tooltip title="Open Group Chat">
//                                     <Button
//                                       variant="contained"
//                                       size="small"
//                                       startIcon={<ChatIcon />}
//                                       onClick={() =>
//                                         this.handleOpenGroupChat(
//                                           group.name,
//                                           group.members,
//                                           group._id,
//                                         )
//                                       }
//                                       sx={{
//                                         borderRadius: 3,
//                                         px: 2,
//                                         background:
//                                           "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                                         color: "white",
//                                         "&:hover": {
//                                           background:
//                                             "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
//                                           transform: "translateY(-2px)",
//                                         },
//                                       }}
//                                     >
//                                       <Badge
//                                         badgeContent={group.unreadCount}
//                                         color="error"
//                                         sx={{ mr: 1 }}
//                                       >
//                                         Chat
//                                       </Badge>
//                                     </Button>
//                                   </Tooltip>

//                                   {/* Action Buttons Group */}
//                                   <Box sx={{ display: "flex", gap: 0.5 }}>
//                                     {/* View Members */}
//                                     <Tooltip title="View Members">
//                                       <IconButton
//                                         size="small"
//                                         color="primary"
//                                         onClick={() => {
//                                           this.setGroup(
//                                             group._id,
//                                             group.members,
//                                           );
//                                           this.setState({
//                                             adminModalOpen: true,
//                                           });
//                                         }}
//                                         sx={{
//                                           bgcolor: "primary.light",
//                                           color: "primary.contrastText",
//                                           "&:hover": {
//                                             bgcolor: "primary.main",
//                                             transform: "translateY(-2px)",
//                                           },
//                                         }}
//                                       >
//                                         <GroupIcon fontSize="small" />
//                                       </IconButton>
//                                     </Tooltip>

//                                     {/* Delete Group */}
//                                     <Tooltip title="Delete Group">
//                                       <IconButton
//                                         size="small"
//                                         onClick={() => this.deleteGroup(group)}
//                                         sx={{
//                                           "& .MuiSvgIcon-root": {
//                                             color: "#f44336",
//                                           },
//                                           "&:hover": {
//                                             backgroundColor:
//                                               "rgba(244, 67, 54, 0.1)",
//                                             transform: "translateY(-2px)",
//                                             "& .MuiSvgIcon-root": {
//                                               color: "#d32f2f",
//                                             },
//                                           },
//                                         }}
//                                       >
//                                         <DeleteIcon />
//                                       </IconButton>
//                                     </Tooltip>
//                                   </Box>
//                                 </Box>
//                               </CardActions>
//                             </StyledCard>
//                           </Zoom>
//                         </Grid2>
//                       ))}
//                   </Grid2>

//                   {/* My Groups Pagination */}
//                   {myGroupsCount > 9 && (
//                     <Paper
//                       elevation={0}
//                       sx={{
//                         p: 2,
//                         mt: 3,
//                         borderRadius: 3,
//                         bgcolor: "background.default",
//                         border: "1px solid",
//                         borderColor: "divider",
//                         boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
//                       }}
//                     >
//                       <Box sx={{ display: "flex", justifyContent: "center" }}>
//                         <PaginatioN
//                           activePage={this.state.myGroupPage}
//                           itemsCountPerPage={9}
//                           totalItemsCount={myGroupsCount}
//                           pageRangeDisplayed={5}
//                           onChange={(page) =>
//                             this.setState({ myGroupPage: page })
//                           }
//                           itemClass="page-item"
//                           linkClass="page-link"
//                           prevPageText={<ArrowBackIcon />}
//                           nextPageText={<ArrowForwardIcon />}
//                           firstPageText={<FirstPageIcon />}
//                           lastPageText={<LastPageIcon />}
//                         />
//                       </Box>
//                     </Paper>
//                   )}
//                 </Box>
//               </Fade>
//             )}

//             {/* Shared Groups Section */}
//             {this.state.otherGroups.length > 0 && (
//               <Fade in timeout={1200}>
//                 <Box sx={{ mb: 4 }}>
//                   <Typography
//                     variant="h5"
//                     fontWeight={600}
//                     gutterBottom
//                     sx={{ mb: 3, display: "flex", alignItems: "center" }}
//                   >
//                     <Box
//                       sx={{
//                         width: 4,
//                         height: 24,
//                         background:
//                           "linear-gradient(135deg, #FF9800 0%, #FF5722 100%)",
//                         borderRadius: 2,
//                         mr: 2,
//                       }}
//                     />
//                     <GroupIcon
//                       sx={{
//                         mr: 1,
//                         verticalAlign: "middle",
//                         color: "warning.main",
//                       }}
//                     />
//                     Shared Groups
//                     <Chip
//                       label={`${otherGroupsCount} Groups`}
//                       size="small"
//                       color="warning"
//                       variant="outlined"
//                       sx={{ ml: 2, fontWeight: 500 }}
//                     />
//                   </Typography>
//                   <Grid2 container spacing={3}>
//                     {filterOtherGroup.length > 0 &&
//                       paginateOtherGroups.map((group, index) => (
//                         <Grid2 xs={12} sm={6} md={4} lg={3} key={group._id}>
//                           <Zoom in timeout={400 + index * 100}>
//                             <StyledCard
//                               sx={{
//                                 background:
//                                   "linear-gradient(135deg, #ffffff 0%, #f9f9f9 100%)",
//                                 "&:hover": {
//                                   background:
//                                     "linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%)",
//                                 },
//                               }}
//                             >
//                               <CardContent sx={{ textAlign: "center", pt: 3 }}>
//                                 <Box
//                                   onClick={() =>
//                                     this.setGroup(group._id, group.members)
//                                   }
//                                   sx={{ cursor: "pointer" }}
//                                 >
//                                   <Box
//                                     sx={{
//                                       display: "inline-flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                       width: 60,
//                                       height: 60,
//                                       borderRadius: "50%",
//                                       background:
//                                         "linear-gradient(135deg, #FF9800 0%, #FF5722 100%)",
//                                       mb: 2,
//                                       boxShadow:
//                                         "0 4px 12px rgba(255, 152, 0, 0.3)",
//                                     }}
//                                   >
//                                     <Typography
//                                       variant="h4"
//                                       fontWeight={700}
//                                       color="white"
//                                     >
//                                       {group.name.charAt(0).toUpperCase()}
//                                     </Typography>
//                                   </Box>
//                                   <Typography
//                                     variant="h6"
//                                     fontWeight={600}
//                                     sx={{ mt: 2, mb: 0.5 }}
//                                   >
//                                     {group.name}
//                                   </Typography>
//                                   <Typography
//                                     variant="body2"
//                                     color="text.primary"
//                                     sx={{ mb: 1 }}
//                                   >
//                                     Admin: {group.ownerName}
//                                   </Typography>
//                                   <Chip
//                                     icon={<GroupIcon fontSize="small" />}
//                                     label={`${group.members.length} ${
//                                       group.members.length === 1
//                                         ? "member"
//                                         : "members"
//                                     }`}
//                                     size="small"
//                                     color="warning"
//                                     variant="outlined"
//                                     sx={{ mt: 1 }}
//                                   />
//                                 </Box>
//                               </CardContent>
//                               <CardActions
//                                 sx={{ justifyContent: "center", pb: 2 }}
//                               >
//                                 <Button
//                                   variant="contained"
//                                   color="warning"
//                                   onClick={() => {
//                                     this.setGroup(group._id, group.members);
//                                     this.setState({ sharedModalOpen: true });
//                                   }}
//                                   startIcon={<GroupIcon />}
//                                   sx={{
//                                     borderRadius: 3,
//                                     px: 3,
//                                     background:
//                                       "linear-gradient(135deg, #FF9800 0%, #FF5722 100%)",
//                                     color: "white",
//                                     "&:hover": {
//                                       background:
//                                         "linear-gradient(135deg, #FF5722 0%, #FF9800 100%)",
//                                       transform: "translateY(-2px)",
//                                     },
//                                   }}
//                                 >
//                                   View Members
//                                 </Button>
//                               </CardActions>
//                             </StyledCard>
//                           </Zoom>
//                         </Grid2>
//                       ))}
//                   </Grid2>
//                 </Box>
//               </Fade>
//             )}
//           </>
//         )}

//         {/* Admin Group Modal */}
//         <CustomDialog
//           open={adminModalOpen}
//           onClose={() => this.setState({ adminModalOpen: false })}
//           maxWidth="lg"
//           fullWidth
//         >
//           <DialogHeader color={{ main: "#667eea", dark: "#764ba2" }}>
//             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//               <GroupIcon fontSize="large" />
//               <Box>
//                 <Typography variant="h5" fontWeight={700}>
//                   Manage Group Members
//                 </Typography>
//                 <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                   Add or remove members from your group
//                 </Typography>
//               </Box>
//             </Box>
//             <IconButton
//               onClick={() => this.setState({ adminModalOpen: false })}
//               sx={{
//                 color: "white !important",
//                 backgroundColor: "#ff4444 !important",
//                 "&:hover": {
//                   backgroundColor: "rgba(255, 68, 68, 0.2)",
//                 },
//               }}
//             >
//               <CloseIcon />
//             </IconButton>
//           </DialogHeader>

//           <DialogContent sx={{ p: 0 }}>
//             <Paper
//               elevation={0}
//               sx={{ p: 3, borderBottom: 1, borderColor: "divider" }}
//             >
//               <SearchTextField
//                 fullWidth
//                 placeholder="Search members by name..."
//                 onChange={this.searchOnChange}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <SearchIcon />
//                     </InputAdornment>
//                   ),
//                   sx: {
//                     borderRadius: 2,
//                     backgroundColor: "#f5f5f5",
//                   },
//                 }}
//               />
//             </Paper>

//             <Grid2 container spacing={0} sx={{ height: "60vh" }}>
//               <Grid2
//                 xs={12}
//                 md={6}
//                 sx={{
//                   borderRight: { md: 1 },
//                   borderColor: "divider",
//                   height: "100%",
//                   display: "flex",
//                   flexDirection: "column",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     p: 3,
//                     borderBottom: 1,
//                     borderColor: "divider",
//                     bgcolor: "background.default",
//                   }}
//                 >
//                   <Typography variant="h6" fontWeight={600} gutterBottom>
//                     <Badge
//                       badgeContent={filterGroup.length}
//                       color="primary"
//                       sx={{ mr: 1 }}
//                     >
//                       Current Members
//                     </Badge>
//                   </Typography>
//                   <Typography variant="body2" color="text.primary">
//                     Members currently in this group
//                   </Typography>
//                 </Box>

//                 <Box
//                   sx={{
//                     flex: 1,
//                     overflowY: "auto",
//                     p: 2,
//                     bgcolor: "background.default",
//                   }}
//                 >
//                   {filterGroup.length > 0 ? (
//                     <Grid2 container spacing={2}>
//                       {filterGroup.map((group) => (
//                         <Grid2 xs={12} key={group._id}>
//                           <Paper
//                             elevation={0}
//                             sx={{
//                               p: 2,
//                               borderRadius: 2,
//                               border: "1px solid",
//                               borderColor: "divider",
//                               transition: "all 0.2s",
//                               "&:hover": {
//                                 borderColor: "primary.main",
//                                 boxShadow:
//                                   "0 4px 12px rgba(102, 126, 234, 0.1)",
//                               },
//                             }}
//                           >
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "space-between",
//                               }}
//                             >
//                               <Box
//                                 sx={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: 2,
//                                 }}
//                               >
//                                 <Badge
//                                   overlap="circular"
//                                   anchorOrigin={{
//                                     vertical: "bottom",
//                                     horizontal: "right",
//                                   }}
//                                   variant="dot"
//                                   color={
//                                     group.status === "online"
//                                       ? "success"
//                                       : "default"
//                                   }
//                                 >
//                                   <Avatar
//                                     sx={{
//                                       bgcolor:
//                                         colors[
//                                           filterGroup.indexOf(group) %
//                                             colors.length
//                                         ],
//                                       width: 48,
//                                       height: 48,
//                                       fontWeight: 600,
//                                       fontSize: "1.25rem",
//                                       boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//                                     }}
//                                   >
//                                     {group.username.charAt(0).toUpperCase()}
//                                   </Avatar>
//                                 </Badge>
//                                 <Box>
//                                   <Typography
//                                     variant="subtitle1"
//                                     fontWeight={600}
//                                   >
//                                     {group.username}
//                                   </Typography>
//                                   <Typography
//                                     variant="caption"
//                                     color="text.primary"
//                                   >
//                                     {group.email || "No email provided"}
//                                   </Typography>
//                                 </Box>
//                               </Box>

//                               <Tooltip title="Remove from group">
//                                 <IconButton
//                                   size="small"
//                                   sx={{
//                                     color: "error.main",
//                                     "&:hover": {
//                                       bgcolor: "error.light",
//                                       color: "error.dark",
//                                       transform: "translateY(-2px)",
//                                     },
//                                   }}
//                                   onClick={() => {
//                                     this.removeMemberFromGroup(group._id);
//                                     this.setState({ adminModalOpen: false });
//                                   }}
//                                 >
//                                   <DeleteIcon />
//                                 </IconButton>
//                               </Tooltip>
//                             </Box>
//                           </Paper>
//                         </Grid2>
//                       ))}
//                     </Grid2>
//                   ) : (
//                     <Box
//                       sx={{
//                         textAlign: "center",
//                         py: 8,
//                         color: "text.primary",
//                       }}
//                     >
//                       <GroupIcon sx={{ fontSize: 60, opacity: 0.3, mb: 2 }} />
//                       <Typography variant="h6" gutterBottom>
//                         No members in this group
//                       </Typography>
//                       <Typography variant="body2">
//                         Add members from your team list
//                       </Typography>
//                     </Box>
//                   )}
//                 </Box>
//               </Grid2>

//               <Grid2
//                 xs={12}
//                 md={6}
//                 sx={{
//                   height: "100%",
//                   display: "flex",
//                   flexDirection: "column",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     p: 3,
//                     borderBottom: 1,
//                     borderColor: "divider",
//                     bgcolor: "background.default",
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <Box>
//                     <Typography variant="h6" fontWeight={600} gutterBottom>
//                       Available Members
//                     </Typography>
//                     <Typography variant="body2" color="text.primary">
//                       Select members to add to group
//                     </Typography>
//                   </Box>

//                   <Button
//                     variant="contained"
//                     size="small"
//                     onClick={this.addMembersToGroup}
//                     disabled={this.state.selectedMembers.length === 0}
//                     startIcon={<PersonAddIcon />}
//                     sx={{
//                       borderRadius: 2,
//                       fontWeight: 600,
//                       px: 3,
//                       background:
//                         "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                       color: "white",
//                       "&:hover": {
//                         background:
//                           "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
//                         transform: "translateY(-2px)",
//                       },
//                     }}
//                   >
//                     Add ({this.state.selectedMembers.length})
//                   </Button>
//                 </Box>

//                 <Box
//                   sx={{
//                     flex: 1,
//                     overflowY: "auto",
//                     p: 2,
//                     bgcolor: "background.default",
//                   }}
//                 >
//                   {filterTeam.length > 0 ? (
//                     <Grid2 container spacing={2}>
//                       {filterTeam.map((team) => (
//                         <Grid2 xs={12} key={team.id}>
//                           <Paper
//                             elevation={0}
//                             sx={{
//                               p: 2,
//                               borderRadius: 2,
//                               border: "1px solid",
//                               borderColor: this.state.selectedMembers.includes(
//                                 team.id,
//                               )
//                                 ? "primary.main"
//                                 : "divider",
//                               bgcolor: this.state.selectedMembers.includes(
//                                 team.id,
//                               )
//                                 ? "primary.lighter"
//                                 : "background.paper",
//                               transition: "all 0.2s",
//                               cursor: "pointer",
//                               "&:hover": {
//                                 borderColor: "primary.main",
//                                 bgcolor: "action.hover",
//                                 transform: "translateY(-2px)",
//                                 boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
//                               },
//                             }}
//                             onClick={() => {
//                               const isSelected =
//                                 this.state.selectedMembers.includes(team.id);
//                               let selected = [...this.state.selectedMembers];

//                               if (isSelected) {
//                                 selected = selected.filter(
//                                   (id) => id !== team.id,
//                                 );
//                               } else {
//                                 selected.push(team.id);
//                               }

//                               this.setState({ selectedMembers: selected });
//                             }}
//                           >
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: 2,
//                               }}
//                             >
//                               <Checkbox
//                                 color="primary"
//                                 checked={this.state.selectedMembers.includes(
//                                   team.id,
//                                 )}
//                                 onChange={this.onChangeSelectionBox(team)}
//                                 onClick={(e) => e.stopPropagation()}
//                                 sx={{
//                                   "&.Mui-checked": {
//                                     color: "primary.main",
//                                   },
//                                 }}
//                               />

//                               <Badge
//                                 overlap="circular"
//                                 anchorOrigin={{
//                                   vertical: "bottom",
//                                   horizontal: "right",
//                                 }}
//                                 variant="dot"
//                                 color={
//                                   team.status === "online"
//                                     ? "success"
//                                     : "default"
//                                 }
//                               >
//                                 <Avatar
//                                   sx={{
//                                     bgcolor:
//                                       colors[
//                                         filterTeam.indexOf(team) % colors.length
//                                       ],
//                                     width: 48,
//                                     height: 48,
//                                     fontWeight: 600,
//                                     fontSize: "1.25rem",
//                                     boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//                                   }}
//                                 >
//                                   {team.name.charAt(0).toUpperCase()}
//                                 </Avatar>
//                               </Badge>

//                               <Box sx={{ flex: 1 }}>
//                                 <Typography
//                                   variant="subtitle1"
//                                   fontWeight={600}
//                                 >
//                                   {team.name || "-"}
//                                 </Typography>
//                                 <Typography
//                                   variant="caption"
//                                   color="text.primary"
//                                 >
//                                   {team.email || "No email provided"}
//                                 </Typography>
//                               </Box>

//                               {this.state.selectedMembers.includes(team.id) && (
//                                 <Chip
//                                   label="Selected"
//                                   color="primary"
//                                   size="small"
//                                   variant="outlined"
//                                   icon={<PersonAddIcon fontSize="small" />}
//                                 />
//                               )}
//                             </Box>
//                           </Paper>
//                         </Grid2>
//                       ))}
//                     </Grid2>
//                   ) : (
//                     <Box
//                       sx={{
//                         textAlign: "center",
//                         py: 8,
//                         color: "text.primary",
//                       }}
//                     >
//                       <PersonIcon sx={{ fontSize: 60, opacity: 0.3, mb: 2 }} />
//                       <Typography variant="h6" gutterBottom>
//                         No team members available
//                       </Typography>
//                       <Typography variant="body2">
//                         Invite team members to get started
//                       </Typography>
//                     </Box>
//                   )}
//                 </Box>
//               </Grid2>
//             </Grid2>
//           </DialogContent>

//           <DialogActions
//             sx={{
//               p: 3,
//               borderTop: 1,
//               borderColor: "divider",
//               justifyContent: "space-between",
//               bgcolor: "background.default",
//             }}
//           >
//             <Box sx={{ display: "flex", gap: 1 }}>
//               <Chip
//                 icon={<GroupIcon />}
//                 label={`${filterGroup.length} members in group`}
//                 color="primary"
//                 variant="outlined"
//               />
//               <Chip
//                 icon={<PersonIcon />}
//                 label={`${filterTeam.length} available members`}
//                 variant="outlined"
//               />
//             </Box>

//             <Box sx={{ display: "flex", gap: 2 }}>
//               <Button
//                 variant="outlined"
//                 onClick={() => this.setState({ adminModalOpen: false })}
//                 sx={{ borderRadius: 2 }}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 variant="contained"
//                 onClick={this.addMembersToGroup}
//                 disabled={this.state.selectedMembers.length === 0}
//                 startIcon={<PersonAddIcon />}
//                 sx={{
//                   borderRadius: 2,
//                   background:
//                     "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                   color: "white",
//                   "&:hover": {
//                     background:
//                       "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
//                     transform: "translateY(-2px)",
//                   },
//                 }}
//               >
//                 Add Selected Members
//               </Button>
//             </Box>
//           </DialogActions>
//         </CustomDialog>

//         {/* Shared Group Modal */}
//         <CustomDialog
//           open={sharedModalOpen}
//           onClose={() => this.setState({ sharedModalOpen: false })}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogHeader color={{ main: "#FF9800", dark: "#FF5722" }}>
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 width: "100%",
//               }}
//             >
//               <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                 <GroupIcon fontSize="large" />
//                 <Box>
//                   <Typography variant="h5" fontWeight={700}>
//                     Shared Group Members
//                   </Typography>
//                   <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                     Members in this shared group
//                   </Typography>
//                 </Box>
//               </Box>

//               <IconButton
//                 onClick={() => this.setState({ sharedModalOpen: false })}
//                 sx={{
//                   color: "white !important",
//                   backgroundColor: "#ff4444 !important",
//                   "&:hover": {
//                     backgroundColor: "rgba(255, 68, 68, 0.2)",
//                   },
//                 }}
//               >
//                 <CloseIcon />
//               </IconButton>
//             </Box>
//           </DialogHeader>
//           <DialogContent dividers sx={{ p: 3 }}>
//             <TextField
//               fullWidth
//               placeholder="Search members..."
//               onChange={this.searchOnChange}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <SearchIcon />
//                   </InputAdornment>
//                 ),
//                 sx: { borderRadius: 2 },
//               }}
//               sx={{ mb: 3 }}
//             />

//             <Box sx={{ maxHeight: "40vh", overflowY: "auto" }}>
//               {filterGroup.length > 0 ? (
//                 filterGroup.map((group) => (
//                   <Paper
//                     key={group._id}
//                     elevation={0}
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 2,
//                       p: 2,
//                       mb: 1.5,
//                       borderRadius: 2,
//                       border: "1px solid",
//                       borderColor: "divider",
//                       "&:hover": {
//                         bgcolor: "action.hover",
//                         borderColor: "warning.main",
//                         transform: "translateY(-2px)",
//                         boxShadow: "0 4px 12px rgba(255, 152, 0, 0.1)",
//                       },
//                       transition: "all 0.2s",
//                     }}
//                   >
//                     <Avatar
//                       sx={{
//                         bgcolor:
//                           colors[filterGroup.indexOf(group) % colors.length],
//                         width: 48,
//                         height: 48,
//                         fontWeight: 600,
//                         fontSize: "1.25rem",
//                       }}
//                     >
//                       {group.username.charAt(0).toUpperCase()}
//                     </Avatar>
//                     <Box>
//                       <Typography fontWeight={600} variant="subtitle1">
//                         {group.username}
//                       </Typography>
//                       <Typography variant="caption" color="text.primary">
//                         {group.email || "No email provided"}
//                       </Typography>
//                     </Box>
//                   </Paper>
//                 ))
//               ) : (
//                 <Box sx={{ textAlign: "center", py: 4 }}>
//                   <GroupIcon sx={{ fontSize: 60, opacity: 0.3, mb: 2 }} />
//                   <Typography color="text.primary" variant="h6">
//                     No members found
//                   </Typography>
//                 </Box>
//               )}
//             </Box>
//           </DialogContent>
//           <DialogActions sx={{ p: 2, bgcolor: "background.default" }}>
//             <Button
//               variant="contained"
//               startIcon={<ExitToAppIcon />}
//               onClick={() => this.leaveGroup()}
//               sx={{
//                 background: "linear-gradient(135deg, #FF5722 0%, #FF9800 100%)",
//                 color: "white",
//                 "&:hover": {
//                   background:
//                     "linear-gradient(135deg, #FF9800 0%, #FF5722 100%)",
//                   transform: "translateY(-2px)",
//                 },
//                 borderRadius: 2,
//               }}
//             >
//               Leave Group
//             </Button>
//             <Button
//               onClick={() => this.setState({ sharedModalOpen: false })}
//               sx={{ borderRadius: 2 }}
//             >
//               Close
//             </Button>
//           </DialogActions>
//         </CustomDialog>

//         <ReactTour
//           steps={this.state.groups.length > 0 ? stepsone : steps}
//           isOpen={this.state.reactTour}
//           closeTour={() => this.setState({ reactTour: false })}
//         />
//       </Box>
//     );
//   }
// }

// const mapStateToProps = (state) => ({
//   currentUser: state.user.currentUser,
//   features: state.features.features,
// });

// const mapDispatchToProps = (dispatch) => ({
//   setCurrentUser: (user) => dispatch(setCurrentUser(user)),
// });

// export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Myteam));

import React, { Component } from "react";
import Loader from "../utils/loader";
import userService from "../services/userService";
import teamService from "../services/teamService";
import Swal from "sweetalert2";
import TeamCard from "./Cards/Teamcard";
import { toast, ToastContainer } from "react-toastify";
import PaginatioN from "react-js-pagination";
import { paginate } from "../utils/paginate";
import "./teamMembers.css";
import Avatars from "./Avatar";
import team from "../static/noteams.png";
import isEmptyObject from "../utils/isEmptyObject";
import { connect } from "react-redux";
import { setCurrentUser } from "../redux/user/user.actions";
import { ReactMultiEmail, isEmail } from "react-multi-email";
import "react-multi-email/style.css";
import _ from "lodash";
import ReactTour from "./ReactTour";
import { withRouter } from "react-router-dom";
import ChatServices from "../services/ChatServices";
import BasicAvatar from "./BasicAvatar";
import { ChatContext } from "../contexts/ChatContext";
import { addUserLogs } from "../services/userLogServices";
import SubscriptionRequired from "./SubscriptionRequired";
import TeamFeatureBot from "../bot/teamBot";
import {
  BOT_TYPES,
  getBotGuideSettings,
  recordBotGuideAutoOpen,
} from "./settingsNew";

// MUI Imports
import {
  Box,
  Card,
  CardContent,
  CardActions,
  TextField,
  Button,
  Typography,
  Divider,
  Popover,
  Tooltip,
  Badge,
  Avatar,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Chip,
  Paper,
  InputAdornment,
  Fade,
  Zoom,
  tooltipClasses,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Add as AddIcon,
  PersonAdd as PersonAddIcon,
  Search as SearchIcon,
  Delete as DeleteIcon,
  Chat as ChatIcon,
  Group as GroupIcon,
  ExitToApp as ExitToAppIcon,
  Close as CloseIcon,
  HelpOutline as HelpIcon,
  MoreVert as MoreVertIcon,
  Person as PersonIcon,
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  FirstPage as FirstPageIcon,
  LastPage as LastPageIcon,
  Email as EmailIcon,
  Cancel as CancelIcon,
  Create as CreateIcon,
  Badge as BadgeIcon,
} from "@mui/icons-material";
import { styled, alpha } from "@mui/material/styles";

// ─── Styled Components ────────────────────────────────────────────────────────

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    boxShadow: theme.shadows[3],
    fontSize: 12,
    fontWeight: 500,
    borderRadius: 8,
    padding: "6px 12px",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
  },
}));

const StyledCard = styled(Card)(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  borderRadius: 16,
  overflow: "hidden",
  "&:hover": {
    transform: "translateY(-8px)",
    boxShadow: theme.shadows[12],
  },
}));

const GradientCard = styled(StyledCard)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
  color: theme.palette.primary.contrastText,
}));

const SearchTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: 50,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    "&.Mui-focused": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
  },
}));

const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: "20px !important",
  width: "50% !important",
  textTransform: "none",
  fontWeight: 600,
  boxShadow: theme.shadows[2],
  backgroundColor: "#e7e3e3ff !important",
  color: "#667eea !important",
  "&:hover": {
    boxShadow: theme.shadows[6],
    backgroundColor: "#c6c3c3ff !important",
  },
}));

const CustomDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 20,
    overflow: "hidden",
    background: `linear-gradient(135deg, ${alpha(
      theme.palette.primary.main,
      0.05
    )} 0%, ${alpha(theme.palette.secondary.main, 0.05)} 100%)`,
  },
}));

const DialogHeader = styled(DialogTitle)(({ theme, color }) => ({
  background: `linear-gradient(135deg, ${color?.main || theme.palette.primary.main} 0%, ${
    color?.dark || theme.palette.primary.dark
  } 100%)`,
  color: theme.palette.primary.contrastText,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(2.5, 3),
  position: "relative",
  "&:after": {
    content: '""',
    position: "absolute",
    bottom: 0,
    left: "5%",
    width: "90%",
    height: "2px",
    background: `linear-gradient(90deg, transparent, ${alpha(
      theme.palette.primary.contrastText,
      0.3
    )}, transparent)`,
  },
}));

const colors = [
  "#bff603","yellow","#80d4ff","orange","#ff8b94","#d3ffce","#9bb7d4",
  "#ffdb58","#f1a7fe","#ff6961","#ffb347","#add8e6","#a0bfe6","#89cff0",
  "#4f86f7","#67e6ec","#7fffd4","#77dd77","#b19cd9","#ff9999",
];

const steps = [
  { selector: ".first-step", content: "Create new group to add members", position: "left" },
  { selector: ".second-step", content: "Enter email to send invite request to member", position: "bottom" },
];

const stepsone = [
  { selector: ".first-step", content: "Create new group to add members", position: "left" },
  { selector: ".second-step", content: "Enter email to send invite request to member", position: "bottom" },
  { selector: ".third-step", content: "Click to view/add members to the group", position: "bottom" },
];

// ─── Component ────────────────────────────────────────────────────────────────

class Myteam extends Component {
  state = {
    loading: true,
    userProfile: "",
    inviteEmail: "",
    inviteEmails: [],
    teamMembers: [],
    totalMemberCount: "",
    currentPage: 1,
    pageSize: 8,
    searchQuery: "",
    groups: [],
    otherGroups: [],
    groupMembers: [],
    groupMemberIDs: [],
    groupName: "",
    groupId: "",
    colorID: 0,
    back: [],
    color: ["#bff603", "yellow", "#80d4ff", "orange"],
    filterTeam: [],
    filterGroup: [],
    filterGroupName: [],
    filterOtherGroup: [],
    selectedMembers: [],
    userFeatures: {},
    myGroupPage: 1,
    otherGroupPage: 1,
    reactTour: false,
    subReqOpen: false,
    inviteAnchorEl: null,
    groupAnchorEl: null,
    adminModalOpen: false,
    sharedModalOpen: false,
    inviteModalOpen: false,
    createGroupModalOpen: false,
    teamBotEnabled: true,
    teamBotAutoStart: false,
  };

  static contextType = ChatContext;

  searchOnChange = (e) => {
    if (e.target.value === "") {
      this.setState({
        filterTeam: this.state.teamMembers,
        filterGroup: this.state.groupMembers,
      });
    } else {
      let value = e.target.value;
      let teamMembers = this.state.teamMembers;
      let groupMembers = this.state.groupMembers;
      let result2 = [];
      let result1 = [];
      result1 = teamMembers.filter((member) => {
        if (member.name.toLowerCase().search(value.toLowerCase()) !== -1) return member;
      });
      result2 = groupMembers.filter((group) => {
        if (group.username.toLowerCase().search(value.toLowerCase()) !== -1) return group;
      });
      this.setState({ filterTeam: result1, filterGroup: result2 });
    }
  };

  handleSearch = (e) => {
    if (e.target.value === "") {
      this.setState({
        filterTeam: this.state.teamMembers,
        filterGroupName: this.state.groups,
        filterOtherGroup: this.state.otherGroups,
      });
    } else {
      let value = e.target.value;
      let teamMembers = this.state.teamMembers;
      let groups = this.state.groups;
      let otherGroups = this.state.otherGroups;

      let result1 = teamMembers.filter((member) => {
        if (member.name.toLowerCase().indexOf(value.toLowerCase()) > -1) return member;
      });
      let result2 = groups.filter((groupmember) => {
        if (groupmember.name.toLowerCase().indexOf(value.toLowerCase()) > -1) return groupmember;
      });
      let result3 = otherGroups.filter((othergroupmember) => {
        if (othergroupmember.name.toLowerCase().indexOf(value.toLowerCase()) > -1) return othergroupmember;
      });

      this.setState({ filterTeam: result1, filterGroupName: result2, filterOtherGroup: result3 });
    }
  };

  async componentDidMount() {
    this.handleBotAccessChange = (event) => {
      if (event?.detail?.botType === BOT_TYPES.TEAM) {
        const guideSettings = getBotGuideSettings(BOT_TYPES.TEAM);
        this.setState({
          teamBotEnabled: event.detail.status === true,
          teamBotAutoStart: guideSettings.shouldAutoOpen,
        });
      }
    };

      const currentUserEmail = sessionStorage.getItem("currentUserEmail");

  if (currentUserEmail) {
    const savedPrefs = localStorage.getItem(`botAccess_${currentUserEmail}`);
    if (savedPrefs) {
      const parsed = JSON.parse(savedPrefs);
      this.setState({
        teamBotEnabled: parsed.team !== false,
      });
    }
  }

    const guideSettings = getBotGuideSettings(BOT_TYPES.TEAM);
    this.setState({
      teamBotAutoStart: guideSettings.shouldAutoOpen,
    });
    window.addEventListener("botAccessChanged", this.handleBotAccessChange);
    setTimeout(() => {
      if (this.props.hasAccess === false) {
        this.setState({ subReqOpen: true, loading: false });
      } else {
        this.getTeam();
      }
    }, 2000);
  }

  componentWillUnmount() {
    window.removeEventListener("botAccessChanged", this.handleBotAccessChange);
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.groupId !== this.state.groupId) {
      this.setState({ selectedMembers: [] });
    }
  }

  getProfile = async () => {
    let user;
    const { currentUser, setCurrentUser, features } = this.props;
    if (currentUser && !isEmptyObject(currentUser)) {
      user = await userService.getProfile();
      user = user.data;
    } else {
      user = await userService.getProfile();
      user = user.data;
      setCurrentUser(user);
    }
    this.setState({ userProfile: user, userFeatures: features }, () => {
      this.getOtherGroups();
    });
  };

  getOtherGroups = async () => {
    let other = this.state.userProfile.groups;
    if (other.length > 0) {
      const othergroups = await teamService.getGroupById(other);
      this.setState({ otherGroups: othergroups.data, filterOtherGroup: othergroups.data });
    } else {
      this.setState({ otherGroups: [] });
    }
    this.setState({ loading: false });
  };

  getTeam = async () => {
    const teamMembers = await userService.getTeam();
    if (teamMembers.status !== 200) {
      this.setState({ teamMembers: [], filterTeam: [] }, () => { this.getGroup(); });
    } else {
      this.setState(
        {
          filterTeam: teamMembers.data.user,
          teamMembers: teamMembers.data.user,
          totalMemberCount: teamMembers.data.user.length,
        },
        () => { this.getGroup(); }
      );
    }
  };

  getGroup = async () => {
    const group = await teamService.getAllGroups();
    if (group.status === 200) {
      this.setState({ groups: group.data, filterGroupName: group.data }, () => { this.getProfile(); });
    } else {
      this.getProfile();
    }
  };

  handleDelete = async (user) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to remove this team member`,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(async (result) => {
      if (result.value === true) {
        this.setState({ loading: true });
        let data = { id: user.id };
        const team = await userService.deleteTeam(data);
        if (team.status === 200) {
          this.getTeam();
          Swal.fire("Deleted!", `${team.message}`, "success");
          const data = {
            userId: sessionStorage.getItem("userId"),
            organizationId: sessionStorage.getItem("organizationId"),
            actionType: "deleteTeamMember",
            userEmail: user.email,
          };
          const addLogs = await addUserLogs(data);
          if (addLogs.status !== 200) toast.error(addLogs.message);
        } else {
          this.setState({ loading: false });
          Swal.fire("Cancelled", `${team.message}`, "error");
        }
      } else {
        Swal.fire("Cancelled", "Your team member is safe :)", "error");
      }
    });
  };

  handlePageChange = (page) => { this.setState({ currentPage: page }); };
  handleSendInvite = (e) => { this.setState({ [e.target.name]: e.target.value }); };
  handleGroupName = (e) => { this.setState({ [e.target.name]: e.target.value }); };

  sendInvite = async (e) => {
    if (this.state.userFeatures?.TeamManagement === false) {
      toast("Please upgrade your plan to enable team member features");
      return;
    }
    this.setState({ loading: true });
    e.preventDefault();
    let email = this.state.inviteEmails;
    if (email.length < 1) {
      this.setState({ loading: false });
      toast.error("Please enter valid email !");
    } else {
      const team = await teamService.inviteMember(email);
      if (team.status !== 200) {
        this.setState({ loading: false });
        toast.error(team.message);
      } else {
        this.setState({ loading: false, inviteModalOpen: false });
        toast.success(team.message);
        const data = {
          userId: sessionStorage.getItem("userId"),
          organizationId: sessionStorage.getItem("organizationId"),
          actionType: "inviteUser",
          userEmail: email,
        };
        const addLogs = await addUserLogs(data);
        if (addLogs.status !== 200) toast.error(addLogs.message);
      }
    }
    this.setState({ inviteEmails: [] });
  };

  setGroup = async (groupid, groupmembers) => {
    let team = this.state.filterTeam;
    this.setState(
      { filterTeam: [], groupMembers: [], filterGroup: [], groupId: groupid, loading: true },
      () => this.setState({ filterTeam: team })
    );
    if (groupmembers.length > 0) {
      const groupdata = await teamService.getGroupMembers(groupmembers);
      if (groupdata.status === 200) {
        this.setState({ groupMembers: groupdata.data, filterGroup: groupdata.data });
      }
    }
    this.setState({ loading: false, groupMemberIDs: groupmembers });
  };

  createGroup = async (e) => {
    e.preventDefault();
    if (this.state.userFeatures?.TeamManagement === false) {
      toast("Please upgrade your plan to enable team member features");
      return;
    }
    this.setState({ loading: true });
    let currentGroup = this.state.groups;
    let groupName = this.state.groupName;
    let userProfile = this.state.userProfile;
    let match = 0;

    if (groupName === "") {
      this.setState({ loading: false });
      toast.error(`Invalid Group Name!`);
      return;
    }

    if (currentGroup.length > 0) {
      for (let i = 0; i < currentGroup.length; i++) {
        if (groupName === currentGroup[i].name) {
          this.setState({ loading: false, groupName: "" });
          toast(`${groupName} Already exists!`);
          match = 1;
          return;
        }
      }
    }

    if (match === 0) {
      let data = { groupname: groupName, ownerName: userProfile.username };
      const team = await teamService.createGroup(data);
      if (team.status === 200) {
        this.getGroup();
        toast.success(team.message);
        this.setState({ createGroupModalOpen: false });
        const data = {
          userId: sessionStorage.getItem("userId"),
          organizationId: sessionStorage.getItem("organizationId"),
          actionType: "createGroup",
        };
        const addLogs = await addUserLogs(data);
        if (addLogs.status !== 200) toast.error(addLogs.message);
      } else {
        this.setState({ loading: false });
        toast.error(team.message);
      }
    }
    this.setState({ groupName: "" });
  };

  onChangeSelectionBox = (team) => (e) => {
    let selected = this.state.selectedMembers;
    if (e.target.checked === true) {
      selected.push(team.id);
    } else {
      selected.splice(selected.indexOf(team.id), 1);
    }
    this.setState({ selectedMembers: selected });
  };

  addMembersToGroup = async () => {
    let groupMembers = this.state.groupMemberIDs;
    let selectedMembers = this.state.selectedMembers;

    if (selectedMembers.length < 1) {
      toast("No Member selected");
      return;
    } else {
      let presents = _.intersectionWith(groupMembers, selectedMembers, _.isEqual);
      if (presents.length > 0) {
        for (let i = 0; i < presents.length; i++) {
          selectedMembers.splice(selectedMembers.indexOf(presents[i]), 1);
        }
      }
    }

    if (selectedMembers.length > 0) {
      let data = { memberArray: selectedMembers, groupID: this.state.groupId };
      const res = await teamService.addMemberToGroup(data);
      if (res.status === 200) {
        this.getGroup();
        toast.success(res.message);
        this.setState({ adminModalOpen: false });
      } else {
        toast.error(res.message);
      }
      this.setState({ selectedMembers: [] });
      return;
    } else {
      toast("Member already exists");
      return;
    }
  };

  removeMemberFromGroup = async (id) => {
    let data = { memberID: id, groupID: this.state.groupId };
    const res = await teamService.removeMemberFromGroup(data);
    if (res.status === 200) {
      this.getGroup();
      toast.success(res.message);
    } else {
      toast.error(res.message);
    }
  };

  leaveGroup = async () => {
    this.setState({ loading: true, sharedModalOpen: false });
    let data = { _id: this.state.groupId };
    const response = await teamService.leaveGroup(data);
    if (response.status === 200) {
      this.getProfile();
      toast.success(response.message);
    } else {
      toast.error(response.message);
      this.setState({ loading: false });
    }
  };

  deleteGroup = async (group) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete ${group.name}`,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(async (result) => {
      if (result.value === true) {
        this.setState({ loading: true });
        let data = { _id: group._id, members: group.members };
        const response = await teamService.deleteGroup(data);
        if (response.status === 200) {
          this.getGroup();
          Swal.fire("Deleted!", `${response.message}`, "success");
          const data = {
            userId: sessionStorage.getItem("userId"),
            organizationId: sessionStorage.getItem("organizationId"),
            actionType: "deleteGroup",
          };
          const addLogs = await addUserLogs(data);
          if (addLogs.status !== 200) toast.error(addLogs.message);
        } else {
          this.setState({ loading: false });
          Swal.fire("Cancelled", `${response.message}`, "error");
        }
      } else {
        Swal.fire("Cancelled", "Your Group is safe :)", "error");
      }
    });
  };

  getPagedData = () => {
    let {
      teamMembers, currentPage, pageSize, searchQuery,
      filterGroupName, filterOtherGroup,
    } = this.state;

    let filteredMembers = teamMembers;

    if (searchQuery) {
      filteredMembers = teamMembers.filter((team) =>
        team.name.toLowerCase().startsWith(searchQuery.toLowerCase())
      );
      filterGroupName = filterGroupName.filter((team) =>
        team.name.toLowerCase().startsWith(searchQuery.toLowerCase())
      );
      filterOtherGroup = filterOtherGroup.filter((team) =>
        team.name.toLowerCase().startsWith(searchQuery.toLowerCase())
      );
    }

    const team = paginate(filteredMembers, currentPage, pageSize);
    const myGroups = paginate(filterGroupName, this.state.myGroupPage, 9);
    const otherGroups = paginate(filterOtherGroup, this.state.otherGroupPage, 9);

    return {
      totalMemberCount: filteredMembers.length,
      teamMembers: team,
      myGroups: myGroups,
      paginateOtherGroups: otherGroups,
      myGroupsCount: filterGroupName.length,
      otherGroupsCount: filterOtherGroup.length,
    };
  };

  handleOpenChat = async (id) => {
    var userProfile = this.state.userProfile;
    try {
      const response = await ChatServices.createContact(userProfile._id, id);
      if (response.status === 200) {
        const { history } = this.props;
        history.push({ pathname: `/chat` });
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
    }
  };

  handleOpenGroupChat = async (groupName, selectedContacts, groupId) => {
    try {
      if (!this.props.hasAccessToChat) {
        this.setState({ subReqOpen: true });
        return;
      }
      const response = await ChatServices.createGroup(groupName, selectedContacts, groupId);
      if (response.status === 200) {
        const { history } = this.props;
        history.push({ pathname: `/chat` });
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
    }
  };

  EmailChip = ({ email, index, removeEmail }) => (
    <Chip
      key={index}
      label={email}
      onDelete={() => removeEmail(index)}
      deleteIcon={<CancelIcon />}
      size="medium"
      color="primary"
      variant="outlined"
      sx={{
        m: 0.5,
        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
        borderColor: (theme) => alpha(theme.palette.primary.main, 0.3),
        "& .MuiChip-deleteIcon": {
          color: (theme) => theme.palette.error.main,
          "&:hover": { color: (theme) => theme.palette.error.dark },
        },
      }}
    />
  );

  render() {
    let {
      filterTeam, filterGroup, filterGroupName, filterOtherGroup,
      subReqOpen, adminModalOpen, sharedModalOpen, inviteModalOpen,
      createGroupModalOpen, inviteEmails, groupName,
    } = this.state;

    let {
      teamMembers, totalMemberCount, myGroups, paginateOtherGroups,
      myGroupsCount, otherGroupsCount,
    } = this.getPagedData();

    return (
      <Box sx={{ p: 3, bgcolor: "#f5f5f5", minHeight: "100vh" }}>
        <Loader loading={this.state.loading} />
        <SubscriptionRequired
          open={subReqOpen}
          setOpen={(val) => this.setState({ subReqOpen: val })}
        />
        <ToastContainer />

        {/* Page Title */}
        <div style={{ height: "10vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <h2 style={{ color: "#012a83", fontSize: "15px", fontWeight: "100", letterSpacing: "2px", margin: 0 }}>
            TEAM WORKSPACE
          </h2>
        </div>

        {/* ── Header Section ── */}
        <Paper
          elevation={0}
          sx={{
            p: 3, mb: 3, borderRadius: 3,
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            position: "relative", overflow: "hidden",
            "&:before": {
              content: '""', position: "absolute", top: -50, right: -50,
              width: 150, height: 150,
              background: "rgba(255,255,255,0.1)", borderRadius: "50%",
            },
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid xs={12} md={6}>
              {/* ── TOUR TARGET: Search ── */}
              <SearchTextField
                id="tour-search"
                fullWidth
                placeholder="Search groups or team members..."
                onChange={this.handleSearch}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "white" }} />
                    </InputAdornment>
                  ),
                  sx: {
                    color: "white",
                    background: "rgba(255,255,255,0.1) !important",
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255,255,255,0.3) !important" },
                    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255,255,255,0.5) !important" },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "white !important" },
                  },
                }}
              />
            </Grid>

            <Grid xs={12} md={6}>
              <Box sx={{ display: "flex", gap: 2, justifyContent: { xs: "flex-start", md: "flex-end" } }}>

                {/* ── TOUR TARGET: Create Group ── */}
                <ActionButton
                  id="tour-create-group"
                  className="first-step"
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => this.setState({ createGroupModalOpen: true })}
                  sx={{
                    background: "linear-gradient(135deg, #fff 0%, #f5f5f5 100%) !important",
                    color: "#667eea !important",
                    "&:hover": {
                      background: "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%) !important",
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  Create Group
                </ActionButton>

                {/* ── TOUR TARGET: Invite ── */}
                <ActionButton
                  id="tour-invite"
                  className="second-step"
                  variant="contained"
                  startIcon={<PersonAddIcon />}
                  onClick={() => this.setState({ inviteModalOpen: true })}
                  sx={{
                    background: "linear-gradient(135deg, #fff 0%, #f5f5f5 100%) !important",
                    color: "#667eea !important",
                    "&:hover": {
                      background: "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%) !important",
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  Invite
                </ActionButton>

                {/* ── TOUR TARGET: Help ── */}
                <LightTooltip title="Need Help?">
                  <IconButton
                    id="tour-help"
                    onClick={() => this.setState({ reactTour: true })}
                    sx={{
                      background: "linear-gradient(135deg, #fff 0%, #f5f5f5 100%) !important",
                      color: "#4762d8 !important",
                      "&:hover": {
                        background: "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%) !important",
                        transform: "translateY(-2px)",
                      },
                      width: 48, height: 48,
                    }}
                  >
                    <HelpIcon />
                  </IconButton>
                </LightTooltip>
              </Box>
            </Grid>
          </Grid>
        </Paper>

        {/* ── Create Group Modal ── */}
        <CustomDialog
          open={createGroupModalOpen}
          onClose={() => this.setState({ createGroupModalOpen: false, groupName: "" })}
          maxWidth="sm"
          fullWidth
        >
          <DialogHeader color={{ main: "#667eea", dark: "#764ba2" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <CreateIcon fontSize="large" />
              <Box>
                <Typography variant="h5" fontWeight={700}>Create New Group</Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>Organize team members into groups</Typography>
              </Box>
            </Box>
          </DialogHeader>

          <DialogContent sx={{ p: 3, pt: 4 }}>
            <form onSubmit={this.createGroup}>
              <Box sx={{ mb: 1, mt: 2 }}>
                <TextField
                  fullWidth
                  placeholder="Enter group name"
                  name="groupName"
                  value={groupName}
                  onChange={this.handleGroupName}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <BadgeIcon sx={{ color: "primary.main" }} />
                      </InputAdornment>
                    ),
                    sx: { borderRadius: 2, "& .MuiOutlinedInput-input": { padding: "12px 14px" } },
                  }}
                  helperText="Choose a unique name for your group"
                  FormHelperTextProps={{ sx: { ml: 0, mt: 1 } }}
                />
              </Box>
              <Box sx={{
                display: "flex", alignItems: "center", gap: 2,
                backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.05),
                p: 2, borderRadius: 2,
                border: (theme) => `1px dashed ${alpha(theme.palette.primary.main, 0.3)}`,
              }}>
                <GroupIcon color="primary" />
                <Box>
                  <Typography variant="body2" fontWeight={500} color="primary">Group Benefits</Typography>
                  <Typography variant="caption" color="text.primary">
                    • Organized collaboration • Group chats • Shared resources
                  </Typography>
                </Box>
              </Box>
            </form>
          </DialogContent>

          <DialogActions sx={{ p: 3, borderTop: 1, borderColor: "divider" }}>
            <Button onClick={() => this.setState({ createGroupModalOpen: false, groupName: "" })} sx={{ borderRadius: 2 }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={this.createGroup}
              disabled={!groupName.trim()}
              startIcon={<CreateIcon />}
              sx={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white !important",
                "&:hover": { background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)", color: "white !important" },
                minWidth: "150px", minHeight: "35px", borderRadius: 2,
              }}
            >
              Create Group
            </Button>
          </DialogActions>
        </CustomDialog>

        {/* ── Invite Modal ── */}
        <CustomDialog
          open={inviteModalOpen}
          onClose={() => this.setState({ inviteModalOpen: false, inviteEmails: [] })}
          maxWidth="sm"
          fullWidth
        >
          <DialogHeader color={{ main: "#667eea", dark: "#764ba2" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <EmailIcon fontSize="large" />
              <Box>
                <Typography variant="h5" fontWeight={700}>Invite Team Members</Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>Send email invitations to collaborate</Typography>
              </Box>
            </Box>
          </DialogHeader>

          <DialogContent sx={{ p: 3 }}>
            <Box sx={{ mb: 1, pt: 3 }}>
              <ReactMultiEmail
                placeholder="Enter email addresses..."
                emails={inviteEmails}
                onChange={(_emails) => { this.setState({ inviteEmails: _emails }); }}
                validateEmail={(email) => isEmail(email)}
                getLabel={(email, index, removeEmail) => (
                  <this.EmailChip email={email} index={index} removeEmail={removeEmail} />
                )}
                inputProps={{
                  style: { width: "100%", border: "none", outline: "none", padding: "8px 0", fontSize: "16px", backgroundColor: "transparent" },
                }}
              />
              {inviteEmails.length > 0 && (
                <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="caption" color="text.primary">
                    {inviteEmails.length} email{inviteEmails.length !== 1 ? "s" : ""} added
                  </Typography>
                  <Chip
                    label="Clear All"
                    size="small"
                    onClick={() => this.setState({ inviteEmails: [] })}
                    sx={{ cursor: "pointer", backgroundColor: "error.main", color: "white", "&:hover": { backgroundColor: "error.dark" } }}
                  />
                </Box>
              )}
            </Box>
            <Box sx={{ backgroundColor: (theme) => alpha(theme.palette.info.main, 0.1), borderRadius: 2, p: 1 }}>
              <Typography variant="body2" color="text.primary" sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <HelpIcon fontSize="small" />
                *Multiple invites can be sent
              </Typography>
            </Box>
          </DialogContent>

          <DialogActions sx={{ p: 3, borderTop: 1, borderColor: "divider" }}>
            <Button onClick={() => this.setState({ inviteModalOpen: false, inviteEmails: [] })} sx={{ borderRadius: 2 }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={this.sendInvite}
              disabled={inviteEmails.length === 0}
              startIcon={<PersonAddIcon />}
              sx={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white !important",
                "&:hover": { background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)", color: "white !important" },
                minWidth: "150px", minHeight: "35px", borderRadius: 2,
              }}
            >
              Send Invites ({inviteEmails.length})
            </Button>
          </DialogActions>
        </CustomDialog>

        {/* ── Empty State ── */}
        {teamMembers.length === 0 && this.state.groups.length === 0 && this.state.otherGroups.length === 0 ? (
          <Box sx={{ textAlign: "center", py: 8 }}>
            <img src={team} alt="No teams" style={{ maxWidth: "400px", opacity: 0.7 }} />
            <Typography variant="h5" color="text.primary" sx={{ mt: 3 }}>No teams or groups yet</Typography>
            <Typography variant="body2" color="text.primary" sx={{ mt: 1 }}>
              Create a group or invite team members to get started
            </Typography>
          </Box>
        ) : (
          <>
            {/* ── Team Members Section ── */}
            {teamMembers.length > 0 && (
              <Fade in timeout={800}>
                {/* TOUR TARGET: team-members section */}
                <Box id="tour-team-members" sx={{ mb: 4 }}>
                  <Typography
                    variant="h5" fontWeight={600} gutterBottom
                    sx={{ mb: 3, display: "flex", alignItems: "center" }}
                  >
                    <Box sx={{ width: 4, height: 24, background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", borderRadius: 2, mr: 2 }} />
                    <GroupIcon sx={{ mr: 1, verticalAlign: "middle", color: "primary.main" }} />
                    Team Members
                    <Chip label={`${teamMembers.length} members`} size="small" color="primary" variant="outlined" sx={{ ml: 2 }} />
                  </Typography>

                  <Grid container spacing={2}>
                    {filterTeam.map((team, idx) => (
                      <Grid xs={12} sm={6} md={4} lg={3} key={team.id}>
                        {/* Add id to first card's wrapper for chat/delete tour targets */}
                        <Box id={idx === 0 ? "tour-member-card" : undefined}>
                          <TeamCard
                            teamdata={team}
                            grpData={this.state.groups}
                            deleteMember={() => this.handleDelete(team)}
                            openChat={() => this.handleOpenChat(team?.id)}
                          />
                        </Box>
                      </Grid>
                    ))}
                  </Grid>

                  {totalMemberCount > 8 && (
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                      <PaginatioN
                        activePage={this.state.currentPage}
                        itemsCountPerPage={this.state.pageSize}
                        totalItemsCount={totalMemberCount}
                        pageRangeDisplayed={3}
                        onChange={this.handlePageChange}
                        itemClass="page-item"
                        linkClass="page-link"
                      />
                    </Box>
                  )}
                </Box>
              </Fade>
            )}

            {/* ── My Groups Section ── */}
            {this.state.groups.length > 0 && (
              <Fade in timeout={1000}>
                {/* TOUR TARGET: my-groups section */}
                <Box id="tour-my-groups" sx={{ mb: 4 }}>
                  <Typography
                    variant="h5" fontWeight={600} gutterBottom
                    sx={{ mb: 3, display: "flex", alignItems: "center" }}
                  >
                    <Box sx={{ width: 4, height: 24, background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", borderRadius: 2, mr: 2 }} />
                    <GroupIcon sx={{ mr: 1, verticalAlign: "middle", color: "primary.main" }} />
                    My Groups
                    <Chip label={`${myGroupsCount} Groups`} size="small" color="primary" variant="outlined" sx={{ ml: 2, fontWeight: 500 }} />
                  </Typography>

                  <Grid container spacing={3}>
                    {filterGroupName.length > 0 &&
                      myGroups.map((group, index) => (
                        <Grid xs={12} sm={4} md={2} lg={3} key={group._id}>
                          <Zoom in timeout={300 + index * 100}>
                            <StyledCard className="third-step">
                              {/* Card Header */}
                              <Box
                                sx={{
                                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                  py: 1.5, textAlign: "center", position: "relative",
                                  "&:hover": { background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)" },
                                }}
                              >
                                <Box onClick={() => this.setGroup(group._id, group.members)} sx={{ cursor: "pointer" }}>
                                  <Box sx={{
                                    display: "inline-flex", alignItems: "center", justifyContent: "center",
                                    width: 50, height: 50, borderRadius: "50%",
                                    bgcolor: "rgba(255,255,255,0.2)", border: "3px solid rgba(255,255,255,0.3)",
                                    transition: "all 0.3s",
                                    "&:hover": { transform: "scale(1.1)", boxShadow: "0 0 20px rgba(255,255,255,0.3)" },
                                  }}>
                                    <Typography variant="h5" fontWeight={700} color="white">
                                      {group.name.charAt(0).toUpperCase()}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>

                              <CardContent sx={{ flexGrow: 1, pt: 2 }}>
                                <Typography
                                  variant="h6" fontWeight={600}
                                  sx={{ mb: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                                  title={group.name}
                                >
                                  {group.name}
                                </Typography>
                                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                                  <PersonIcon fontSize="small" sx={{ mr: 0.5, color: "text.primary" }} />
                                  <Typography variant="body2" color="text.primary">
                                    Admin: <span style={{ fontWeight: 500 }}>{this.state.userProfile.username}</span>
                                  </Typography>
                                </Box>
                                <Chip
                                  icon={<GroupIcon fontSize="small" />}
                                  label={`${group.members.length} ${group.members.length === 1 ? "member" : "members"}`}
                                  size="small" variant="outlined" sx={{ mb: 1 }}
                                />
                              </CardContent>

                              <CardActions sx={{ p: 1.5, bgcolor: "background.default", borderTop: "1px solid", borderColor: "divider" }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                  {/* TOUR TARGET: group chat button (first card) */}
                                  <LightTooltip title="Open Group Chat">
                                    <Button
                                      id={index === 0 ? "tour-group-chat" : undefined}
                                      variant="contained"
                                      size="small"
                                      startIcon={<ChatIcon />}
                                      onClick={() => this.handleOpenGroupChat(group.name, group.members, group._id)}
                                      sx={{
                                        borderRadius: 3, px: 2,
                                        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                        color: "white",
                                        "&:hover": { background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)", transform: "translateY(-2px)" },
                                      }}
                                    >
                                      <Badge badgeContent={group.unreadCount} color="error" sx={{ mr: 1 }}>
                                        Chat
                                      </Badge>
                                    </Button>
                                  </LightTooltip>

                                  <Box sx={{ display: "flex", gap: 0.5 }}>
                                    {/* TOUR TARGET: manage members button (first card) */}
                                    <LightTooltip title="View Members">
                                      <IconButton
                                        id={index === 0 ? "tour-group-manage" : undefined}
                                        size="small"
                                        color="primary"
                                        onClick={() => {
                                          this.setGroup(group._id, group.members);
                                          this.setState({ adminModalOpen: true });
                                        }}
                                        sx={{
                                          bgcolor: "primary.light",
                                          color: "primary.contrastText",
                                          "&:hover": { bgcolor: "primary.main", transform: "translateY(-2px)" },
                                        }}
                                      >
                                        <GroupIcon fontSize="small" />
                                      </IconButton>
                                    </LightTooltip>

                                    <LightTooltip title="Delete Group">
                                      <IconButton
                                        size="small"
                                        onClick={() => this.deleteGroup(group)}
                                        sx={{
                                          "& .MuiSvgIcon-root": { color: "#f44336" },
                                          "&:hover": {
                                            backgroundColor: "rgba(244, 67, 54, 0.1)",
                                            transform: "translateY(-2px)",
                                            "& .MuiSvgIcon-root": { color: "#d32f2f" },
                                          },
                                        }}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </LightTooltip>
                                  </Box>
                                </Box>
                              </CardActions>
                            </StyledCard>
                          </Zoom>
                        </Grid>
                      ))}
                  </Grid>

                  {myGroupsCount > 9 && (
                    <Paper elevation={0} sx={{ p: 2, mt: 3, borderRadius: 3, bgcolor: "background.default", border: "1px solid", borderColor: "divider", boxShadow: "0 4px 12px rgba(0,0,0,0.05)" }}>
                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <PaginatioN
                          activePage={this.state.myGroupPage}
                          itemsCountPerPage={9}
                          totalItemsCount={myGroupsCount}
                          pageRangeDisplayed={5}
                          onChange={(page) => this.setState({ myGroupPage: page })}
                          itemClass="page-item"
                          linkClass="page-link"
                          prevPageText={<ArrowBackIcon />}
                          nextPageText={<ArrowForwardIcon />}
                          firstPageText={<FirstPageIcon />}
                          lastPageText={<LastPageIcon />}
                        />
                      </Box>
                    </Paper>
                  )}
                </Box>
              </Fade>
            )}

            {/* ── Shared Groups Section ── */}
            {this.state.otherGroups.length > 0 && (
              <Fade in timeout={1200}>
                {/* TOUR TARGET: shared-groups section */}
                <Box id="tour-shared-groups" sx={{ mb: 4 }}>
                  <Typography
                    variant="h5" fontWeight={600} gutterBottom
                    sx={{ mb: 3, display: "flex", alignItems: "center" }}
                  >
                    <Box sx={{ width: 4, height: 24, background: "linear-gradient(135deg, #FF9800 0%, #FF5722 100%)", borderRadius: 2, mr: 2 }} />
                    <GroupIcon sx={{ mr: 1, verticalAlign: "middle", color: "warning.main" }} />
                    Shared Groups
                    <Chip label={`${otherGroupsCount} Groups`} size="small" color="warning" variant="outlined" sx={{ ml: 2, fontWeight: 500 }} />
                  </Typography>

                  <Grid container spacing={3}>
                    {filterOtherGroup.length > 0 &&
                      paginateOtherGroups.map((group, index) => (
                        <Grid xs={12} sm={6} md={4} lg={3} key={group._id}>
                          <Zoom in timeout={400 + index * 100}>
                            <StyledCard sx={{ background: "linear-gradient(135deg, #ffffff 0%, #f9f9f9 100%)", "&:hover": { background: "linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%)" } }}>
                              <CardContent sx={{ textAlign: "center", pt: 3 }}>
                                <Box onClick={() => this.setGroup(group._id, group.members)} sx={{ cursor: "pointer" }}>
                                  <Box sx={{
                                    display: "inline-flex", alignItems: "center", justifyContent: "center",
                                    width: 60, height: 60, borderRadius: "50%",
                                    background: "linear-gradient(135deg, #FF9800 0%, #FF5722 100%)",
                                    mb: 2, boxShadow: "0 4px 12px rgba(255, 152, 0, 0.3)",
                                  }}>
                                    <Typography variant="h4" fontWeight={700} color="white">
                                      {group.name.charAt(0).toUpperCase()}
                                    </Typography>
                                  </Box>
                                  <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 0.5 }}>{group.name}</Typography>
                                  <Typography variant="body2" color="text.primary" sx={{ mb: 1 }}>Admin: {group.ownerName}</Typography>
                                  <Chip
                                    icon={<GroupIcon fontSize="small" />}
                                    label={`${group.members.length} ${group.members.length === 1 ? "member" : "members"}`}
                                    size="small" color="warning" variant="outlined" sx={{ mt: 1 }}
                                  />
                                </Box>
                              </CardContent>
                              <CardActions sx={{ justifyContent: "center", pb: 2 }}>
                                <Button
                                  variant="contained"
                                  color="warning"
                                  onClick={() => { this.setGroup(group._id, group.members); this.setState({ sharedModalOpen: true }); }}
                                  startIcon={<GroupIcon />}
                                  sx={{
                                    borderRadius: 3, px: 3,
                                    background: "linear-gradient(135deg, #FF9800 0%, #FF5722 100%)",
                                    color: "white",
                                    "&:hover": { background: "linear-gradient(135deg, #FF5722 0%, #FF9800 100%)", transform: "translateY(-2px)" },
                                  }}
                                >
                                  View Members
                                </Button>
                              </CardActions>
                            </StyledCard>
                          </Zoom>
                        </Grid>
                      ))}
                  </Grid>
                </Box>
              </Fade>
            )}
          </>
        )}

        {/* ── Admin Group Modal ── */}
        <CustomDialog open={adminModalOpen} onClose={() => this.setState({ adminModalOpen: false })} maxWidth="lg" fullWidth>
          <DialogHeader color={{ main: "#667eea", dark: "#764ba2" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <GroupIcon fontSize="large" />
              <Box>
                <Typography variant="h5" fontWeight={700}>Manage Group Members</Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>Add or remove members from your group</Typography>
              </Box>
            </Box>
            <IconButton
              onClick={() => this.setState({ adminModalOpen: false })}
              sx={{ color: "white !important", backgroundColor: "#ff4444 !important", "&:hover": { backgroundColor: "rgba(255, 68, 68, 0.2)" } }}
            >
              <CloseIcon />
            </IconButton>
          </DialogHeader>

          <DialogContent sx={{ p: 0 }}>
            <Paper elevation={0} sx={{ p: 3, borderBottom: 1, borderColor: "divider" }}>
              <SearchTextField
                fullWidth
                placeholder="Search members by name..."
                onChange={this.searchOnChange}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                  sx: { borderRadius: 2, backgroundColor: "#f5f5f5" },
                }}
              />
            </Paper>

            <Grid container spacing={0} sx={{ height: "60vh" }}>
              {/* Current Members */}
              <Grid xs={12} md={6} sx={{ borderRight: { md: 1 }, borderColor: "divider", height: "100%", display: "flex", flexDirection: "column" }}>
                <Box sx={{ p: 3, borderBottom: 1, borderColor: "divider", bgcolor: "background.default" }}>
                  <Typography variant="h6" fontWeight={600} gutterBottom>
                    <Badge badgeContent={filterGroup.length} color="primary" sx={{ mr: 1 }}>Current Members</Badge>
                  </Typography>
                  <Typography variant="body2" color="text.primary">Members currently in this group</Typography>
                </Box>
                <Box sx={{ flex: 1, overflowY: "auto", p: 2, bgcolor: "background.default" }}>
                  {filterGroup.length > 0 ? (
                    <Grid container spacing={2}>
                      {filterGroup.map((group) => (
                        <Grid xs={12} key={group._id}>
                          <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: "1px solid", borderColor: "divider", transition: "all 0.2s", "&:hover": { borderColor: "primary.main", boxShadow: "0 4px 12px rgba(102, 126, 234, 0.1)" } }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                <Badge overlap="circular" anchorOrigin={{ vertical: "bottom", horizontal: "right" }} variant="dot" color={group.status === "online" ? "success" : "default"}>
                                  <Avatar sx={{ bgcolor: colors[filterGroup.indexOf(group) % colors.length], width: 48, height: 48, fontWeight: 600, fontSize: "1.25rem", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
                                    {group.username.charAt(0).toUpperCase()}
                                  </Avatar>
                                </Badge>
                                <Box>
                                  <Typography variant="subtitle1" fontWeight={600}>{group.username}</Typography>
                                  <Typography variant="caption" color="text.primary">{group.email || "No email provided"}</Typography>
                                </Box>
                              </Box>
                              <LightTooltip title="Remove from group">
                                <IconButton
                                  size="small"
                                  sx={{ color: "error.main", "&:hover": { bgcolor: "error.light", color: "error.dark", transform: "translateY(-2px)" } }}
                                  onClick={() => { this.removeMemberFromGroup(group._id); this.setState({ adminModalOpen: false }); }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </LightTooltip>
                            </Box>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  ) : (
                    <Box sx={{ textAlign: "center", py: 8, color: "text.primary" }}>
                      <GroupIcon sx={{ fontSize: 60, opacity: 0.3, mb: 2 }} />
                      <Typography variant="h6" gutterBottom>No members in this group</Typography>
                      <Typography variant="body2">Add members from your team list</Typography>
                    </Box>
                  )}
                </Box>
              </Grid>

              {/* Available Members */}
              <Grid xs={12} md={6} sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                <Box sx={{ p: 3, borderBottom: 1, borderColor: "divider", bgcolor: "background.default", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Box>
                    <Typography variant="h6" fontWeight={600} gutterBottom>Available Members</Typography>
                    <Typography variant="body2" color="text.primary">Select members to add to group</Typography>
                  </Box>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={this.addMembersToGroup}
                    disabled={this.state.selectedMembers.length === 0}
                    startIcon={<PersonAddIcon />}
                    sx={{
                      borderRadius: 2, fontWeight: 600, px: 3,
                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      color: "white",
                      "&:hover": { background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)", transform: "translateY(-2px)" },
                    }}
                  >
                    Add ({this.state.selectedMembers.length})
                  </Button>
                </Box>
                <Box sx={{ flex: 1, overflowY: "auto", p: 2, bgcolor: "background.default" }}>
                  {filterTeam.length > 0 ? (
                    <Grid container spacing={2}>
                      {filterTeam.map((team) => (
                        <Grid xs={12} key={team.id}>
                          <Paper
                            elevation={0}
                            sx={{
                              p: 2, borderRadius: 2, border: "1px solid",
                              borderColor: this.state.selectedMembers.includes(team.id) ? "primary.main" : "divider",
                              bgcolor: this.state.selectedMembers.includes(team.id) ? "primary.lighter" : "background.paper",
                              transition: "all 0.2s", cursor: "pointer",
                              "&:hover": { borderColor: "primary.main", bgcolor: "action.hover", transform: "translateY(-2px)", boxShadow: "0 4px 12px rgba(0,0,0,0.05)" },
                            }}
                            onClick={() => {
                              const isSelected = this.state.selectedMembers.includes(team.id);
                              let selected = [...this.state.selectedMembers];
                              if (isSelected) { selected = selected.filter((id) => id !== team.id); } else { selected.push(team.id); }
                              this.setState({ selectedMembers: selected });
                            }}
                          >
                            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                              <Checkbox
                                color="primary"
                                checked={this.state.selectedMembers.includes(team.id)}
                                onChange={this.onChangeSelectionBox(team)}
                                onClick={(e) => e.stopPropagation()}
                              />
                              <Badge overlap="circular" anchorOrigin={{ vertical: "bottom", horizontal: "right" }} variant="dot" color={team.status === "online" ? "success" : "default"}>
                                <Avatar sx={{ bgcolor: colors[filterTeam.indexOf(team) % colors.length], width: 48, height: 48, fontWeight: 600, fontSize: "1.25rem", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
                                  {team.name.charAt(0).toUpperCase()}
                                </Avatar>
                              </Badge>
                              <Box sx={{ flex: 1 }}>
                                <Typography variant="subtitle1" fontWeight={600}>{team.name || "-"}</Typography>
                                <Typography variant="caption" color="text.primary">{team.email || "No email provided"}</Typography>
                              </Box>
                              {this.state.selectedMembers.includes(team.id) && (
                                <Chip label="Selected" color="primary" size="small" variant="outlined" icon={<PersonAddIcon fontSize="small" />} />
                              )}
                            </Box>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  ) : (
                    <Box sx={{ textAlign: "center", py: 8, color: "text.primary" }}>
                      <PersonIcon sx={{ fontSize: 60, opacity: 0.3, mb: 2 }} />
                      <Typography variant="h6" gutterBottom>No team members available</Typography>
                      <Typography variant="body2">Invite team members to get started</Typography>
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ p: 3, borderTop: 1, borderColor: "divider", justifyContent: "space-between", bgcolor: "background.default" }}>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Chip icon={<GroupIcon />} label={`${filterGroup.length} members in group`} color="primary" variant="outlined" />
              <Chip icon={<PersonIcon />} label={`${filterTeam.length} available members`} variant="outlined" />
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button variant="outlined" onClick={() => this.setState({ adminModalOpen: false })} sx={{ borderRadius: 2 }}>Cancel</Button>
              <Button
                variant="contained"
                onClick={this.addMembersToGroup}
                disabled={this.state.selectedMembers.length === 0}
                startIcon={<PersonAddIcon />}
                sx={{
                  borderRadius: 2,
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  color: "white",
                  "&:hover": { background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)", transform: "translateY(-2px)" },
                }}
              >
                Add Selected Members
              </Button>
            </Box>
          </DialogActions>
        </CustomDialog>

        {/* ── Shared Group Modal ── */}
        <CustomDialog open={sharedModalOpen} onClose={() => this.setState({ sharedModalOpen: false })} maxWidth="sm" fullWidth>
          <DialogHeader color={{ main: "#FF9800", dark: "#FF5722" }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <GroupIcon fontSize="large" />
                <Box>
                  <Typography variant="h5" fontWeight={700}>Shared Group Members</Typography>
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>Members in this shared group</Typography>
                </Box>
              </Box>
              <IconButton
                onClick={() => this.setState({ sharedModalOpen: false })}
                sx={{ color: "white !important", backgroundColor: "#ff4444 !important", "&:hover": { backgroundColor: "rgba(255, 68, 68, 0.2)" } }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogHeader>

          <DialogContent dividers sx={{ p: 3 }}>
            <TextField
              fullWidth
              placeholder="Search members..."
              onChange={this.searchOnChange}
              InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>, sx: { borderRadius: 2 } }}
              sx={{ mb: 3 }}
            />
            <Box sx={{ maxHeight: "40vh", overflowY: "auto" }}>
              {filterGroup.length > 0 ? (
                filterGroup.map((group) => (
                  <Paper key={group._id} elevation={0} sx={{ display: "flex", alignItems: "center", gap: 2, p: 2, mb: 1.5, borderRadius: 2, border: "1px solid", borderColor: "divider", "&:hover": { bgcolor: "action.hover", borderColor: "warning.main", transform: "translateY(-2px)", boxShadow: "0 4px 12px rgba(255, 152, 0, 0.1)" }, transition: "all 0.2s" }}>
                    <Avatar sx={{ bgcolor: colors[filterGroup.indexOf(group) % colors.length], width: 48, height: 48, fontWeight: 600, fontSize: "1.25rem" }}>
                      {group.username.charAt(0).toUpperCase()}
                    </Avatar>
                    <Box>
                      <Typography fontWeight={600} variant="subtitle1">{group.username}</Typography>
                      <Typography variant="caption" color="text.primary">{group.email || "No email provided"}</Typography>
                    </Box>
                  </Paper>
                ))
              ) : (
                <Box sx={{ textAlign: "center", py: 4 }}>
                  <GroupIcon sx={{ fontSize: 60, opacity: 0.3, mb: 2 }} />
                  <Typography color="text.primary" variant="h6">No members found</Typography>
                </Box>
              )}
            </Box>
          </DialogContent>

          <DialogActions sx={{ p: 2, bgcolor: "background.default" }}>
            <Button
              variant="contained"
              startIcon={<ExitToAppIcon />}
              onClick={() => this.leaveGroup()}
              sx={{
                background: "linear-gradient(135deg, #FF5722 0%, #FF9800 100%)",
                color: "white",
                "&:hover": { background: "linear-gradient(135deg, #FF9800 0%, #FF5722 100%)", transform: "translateY(-2px)" },
                borderRadius: 2,
              }}
            >
              Leave Group
            </Button>
            <Button onClick={() => this.setState({ sharedModalOpen: false })} sx={{ borderRadius: 2 }}>Close</Button>
          </DialogActions>
        </CustomDialog>

        {/* ── React Tour ── */}
        <ReactTour
          steps={this.state.groups.length > 0 ? stepsone : steps}
          isOpen={this.state.reactTour}
          closeTour={() => this.setState({ reactTour: false })}
        />

        {/* ── 🤖 Team Feature Bot ── */}
       <TeamFeatureBot
         show={this.state.teamBotEnabled}
         autoStart={this.state.teamBotAutoStart}
         onAutoStart={() => {
           recordBotGuideAutoOpen(BOT_TYPES.TEAM);
           this.setState({ teamBotAutoStart: false });
         }}
       />
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  features: state.features.features,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Myteam));

